import { DatePipe } from '@angular/common';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { SignaturePad } from 'angular2-signaturepad';

import { ToastrService } from 'ngx-toastr';
import { forkJoin, Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonHttpService } from 'src/app/common.service';
import { DateService } from 'src/app/date.service';
import { GlobalComponent } from 'src/app/global/global.component';
import { BasicAdvance, budgetBO, GetClientEvaluation } from '../budgetimport/budgetimport.model';
import {
  AdditionalAddress, AdditionalContactBO, AgencyDetails, AnnualBudgetBO, AuthBo, BudgetEvaluationOfLastYearPlansBO, BudgetExpendituresMonitorBO, BudgetHealthandSafetyMonitors, BudgetImportBO, CaseManagerBO, ClientContactInfoBO, ClientDetailsShow, CommonAddressBO,
  DoctorAdressBO, EnvironmentalModificationAndProvisionsBO, EvaluationOfLastYearPlanBO, goalBO, GoalBO,
  Goals,
  healthandSafetyPlan, HospitalBO, MonitorBO, NursingServicesBO, ParentOrLegalRepresentativeOrManagingPartyBO,
  PersonalAssistanceBO, PersonalCareAttendanceBO, personRecevingServicesBO, PlanBO, RepresentativeContacts, RepresentativeContactsBO, ResidentDetailsBO,
  SchduleWeekBo, ScheduleBO, SchoolBo, SelfDirectionSupportActivitiesBO, ServiceAssistanceBO, SupportPlannerDetailsBO, TreatmentAndTrainingBO,
  WhowillMonitorBO, WhowillresponceBO
} from './budgetplan-form.model';
import { budgetService } from './budgetplan-form.service';
import { IMyDateModel, IMyDpOptions, IMyInputFieldChanged } from 'mydatepicker';
import { DataStateChangeEventArgs, FilterSettingsModel, IFilter } from '@syncfusion/ej2-grids';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ContactInfoLst } from '../client-parent/client-parent.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { budgetlistService } from '../budgetimport/budgetimportdata.service';
// import { generalservice } from 'src/app/services/general.service';
import { caseManagerList } from '../case-manager/case-manager.model';
// import { ZipcodeDetail } from '../agency/agency.model';
import { SupportPlannerBO } from '../supportplanner/supportplanner.model';
import { supportService } from '../supportplanner/supportplanner.service';
import { GeneralService } from 'src/app/service/general.service';
import { budgetformService } from '../budgetimport/budgetimport.service';

@Component({
  selector: 'app-budgetplan-form',
  templateUrl: './budgetplan-form.component.html',
  styleUrls: ['./budgetplan-form.component.scss']
})
export class BudgetplanFormComponent implements OnInit {
  public dataOnBoardclient: Observable<DataStateChangeEventArgs>;
  // serviceAssistances: budgetImportBO.personalAssistance.serviceAssistances[] =new budgetImportBO.personalAssistance.serviceAssistances[];
  // schduleWeeks:SchduleWeekBo[]=[];
  // whowillMonitors:WhowillMonitorBO[]=[];
  // whowillMonitors1:WhowillMonitorBO[]=[];
  budgetImportBO: BudgetImportBO = new BudgetImportBO();
  updateAuthList: any = new BudgetImportBO();
  Case: caseManagerList = new caseManagerList();
  @Input() BudgetView:any;

  @ViewChild("recipientsignaturePad") recipientsignaturePad: SignaturePad;
  @ViewChild("parentsignaturePad1") parentsignaturePad1: SignaturePad;
  @ViewChild("leadAgencysignaturePad1") leadAgencysignaturePad1: SignaturePad;
  @ViewChild("leadAgencysignaturePad2") leadAgencysignaturePad2: SignaturePad;
  @Input() budgetPlan: BudgetImportBO = new BudgetImportBO();
  @Input() budgetImprtPlan: BudgetImportBO = new BudgetImportBO();
  @Output() dataEmitFromCDCSPlan = new EventEmitter<budgetBO>();
  @Output() dataEmitFromCDCSPlan1= new EventEmitter<BasicAdvance>();

  // today = new Date();
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    // disableSince: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 },
    showClearDateBtn: false,
    editableDateField: true
  };
  public myDatePickerOptionsTo: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    // disableSince: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 },
    showClearDateBtn: false,
    editableDateField: true
  };
  public signaturePadOptions: Object = { // passed through to szimek/signature_pad constructor
    'minWidth': 5,
    'canvasWidth': 500,
    'canvasHeight': 200,
    'maxWidth': 5,
    'penColor': "blue"

  };
  receipentSign: string = "";
  parentSign: string = "";
  leadAgencySign1: string = "";
  leadAgencySign2: string = "";

  contactinfo: ClientContactInfoBO = new ClientContactInfoBO();


  public budgetform: FormGroup;
  public validform: FormGroup;
  public validform1: FormGroup;
  public CaseForm: FormGroup
  public ContactInfoForm: FormGroup;
  form: FormGroup
  form1:FormGroup
  emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";

  constructor(public general: GeneralService, public supportser: supportService, public budgetService: budgetService, public ngxservice: NgxUiLoaderService, private formbuilber: FormBuilder, public commonhttp: CommonHttpService, public datepipe: DatePipe, public dateservice: DateService, public global: GlobalComponent, public toastrService: ToastrService, private http: HttpClient,public budgetformService:budgetformService) {
    this.global.checkforlogout();
    this.budgetform = this.formbuilber.group({
      
      date1: ["", Validators.required],
      date2: ["", Validators.required],
      type: ["", Validators.required],
      client: ["", Validators.required],
      insuranceNo:["",Validators.required],
      amount: ["", Validators.required]
    });
    this.form1=formbuilber.group({
     
      name: [' ',Validators.required],     
      zip:['', [Validators.minLength(5), Validators.maxLength(11)]],
      phone: ['', [Validators.minLength(10), Validators.maxLength(10)]],
      fax: ['', [Validators.minLength(10), Validators.maxLength(10)]],     
      email: ['', [Validators.email]]
    })

    this.CaseForm = this.formbuilber.group({
      name: [' ',Validators.required],
      street: ['',],
      state: [''],
      city: [''],
      zip: ['', [Validators.required,Validators.minLength(5), Validators.maxLength(11)]],
      phone: ['', [Validators.minLength(14), Validators.maxLength(14)]],
      fax: ['', [Validators.minLength(14), Validators.maxLength(14)]],
      email: ['', [Validators.email]]
    });


    this.validform = this.formbuilber.group({
      // Personemail: ["",Validators.email],

      Personphn: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      Personzip: ["", [Validators.minLength(5), Validators.maxLength(11)]],
      // Leademail: ["",Validators.email],
      Leadphn: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      Leadfax: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      Leadzip: ["", [Validators.minLength(5), Validators.maxLength(11)]],
      // Fiscalemail: ["",Validators.email],
      Fiscalphn: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      Fiscalfax: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      Fiscalzip: ["", [Validators.minLength(5), Validators.maxLength(11)]],
      // Supportemail: ["",Validators.email],
      Supportphn: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      Supportfax: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      Supportzip: ["", [Validators.minLength(5), Validators.maxLength(11)]],
      Doctorphn: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      Doctorfax: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      Doctorzip: ["", [Validators.minLength(5), Validators.maxLength(11)]],
      Hospitalphn: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      Hospitalfax: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      Hospitalzip: ["", [Validators.minLength(5), Validators.maxLength(11)]],
      Schoolphn: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      Schoolfax: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      Schoolzip: ["", [Validators.minLength(5), Validators.maxLength(11)]],
      Altphn: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      Altphn1: ["", [Validators.minLength(14), Validators.maxLength(14)]],

    })
    this.validform1 = this.formbuilber.group({
      date: ["", Validators.required],
      persondate: ["", Validators.required],
      anualsdate: ["", Validators.required],
      anualedate: ["", Validators.required],
      date1: ["", Validators.required],
      persondate1: ["", Validators.required],
      anualsdate1: ["", Validators.required],
      anualedate1: ["", Validators.required],
      date2: ["", Validators.required],

    });
    this.ContactInfoForm = this.formbuilber.group({
      Name: [' ', Validators.required],
      ContactTypes: [' ', Validators.required],
      phoneCarrier: [' ',],
      RelationshipType: [' ',],
      phoneNumber: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      alternatePhoneNumber: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      fax: [' ', [Validators.minLength(14), Validators.maxLength(14)]],
      street: [' '],
      city: [' '],
      email: [' '],
      state: [' '],
      zip: [' '],
      clinic: [' '],

    }),
      this.form = formbuilber.group({
        email: ['', [Validators.required, Validators.email]],
      })
  
      

  }
  private onDestroy$: Subject<void> = new Subject<void>();
  filterOptions: FilterSettingsModel;
  filter: IFilter;
  // evaluationOfLastYearPlan:EvaluationOfLastYearPlanBO[]=[];
  locationLid: any;
  stateList: any = [];
  bind_ContactData: ClientContactInfoBO[] = []
  bind_AdditionalContactData: ClientContactInfoBO[] = []


  persoanlAssisGoal: Goals[] = [];
  EnvironmentalGoal: Goals[] = [];
  TreatmentGoal: Goals[] = [];
  SelfServiceGoal: Goals[] = [];
  clientIdCheck: boolean
  clientValue:any
  // stateList:any=[]
  ngOnInit(): void {
    this.commonhttp.getJSON().pipe(takeUntil(this.onDestroy$)).subscribe(data => {
      this.stateList = data;
  
     
    });
   
    if (this.global.LoginEntityType == 'CLIENT') {
      this.budgetPlan.isDisable = true
    }
    // this.GetPersonalServiceDropdown();
    // this.GetTreatMentDropdown();
    // this.GetEnvironmentDropdown();

    // this.GetSelfDropdown();
    //  this.getClientInfo(this.budgetPlan.clientId)
    this.getPhoneCarrierStatus();
    this.getstaffing();
    // this.getschudule();
    // this.getschudule1();
    this.getPayorList();
    this.getannual();
    this.getemp();
    // this.getplan();
    this.getbudget();
    this.getContactRelationStatus();
    this.getContactType();
    this.filterOptions = { type: 'Menu' };
    this.filter = {
      type: 'menu'
    };

    this.getCaseManagerDetails()
    this.getSupportPlannerDetails()
    this.getAgencyetails()
    this.getAllClientDropDown();
    this.GetCompanyNameDropdown();

   
  
    if (this.global.globalLocationId != null && this.global.globalLocationId != ''
      && this.global.globalLocationId != undefined) {

      this.locationLid = this.global.globalLocationId;

    }
    else {
      this.locationLid = "00000000-0000-0000-0000-000000000000";
    }


    if (this.global.LoginEntityType == 'CLIENT') {
      this.budgetform.disable();
    }




    if (this.budgetPlan.id == "00000000-0000-0000-0000-000000000000") {
      this.budgetImportBO.clientId = (this.budgetPlan.clientId != null && this.budgetPlan.clientId != "00000000-0000-0000-0000-000000000000") ? this.budgetPlan.clientId : null;
      if ((this.budgetPlan.clientId != null && this.budgetPlan.clientId != "00000000-0000-0000-0000-000000000000")) {
        this.budgetform.get('client').disable();
        this.bind_ClientValues(this.budgetPlan.clientId);
        this.getClientContact(this.budgetPlan.clientId);
      } else {
        this.budgetform.get('client').enable();
      }
      this.budgetform.get('date1').enable();
      this.budgetform.get('date2').enable();
      this.budgetImportBO.personalAssistanceGrandTotal = 0;
      this.budgetImportBO.treatmentTrainingGrandTotal = 0;
      this.budgetImportBO.environmentalModsGrandTotal = 0;
      this.budgetImportBO.selfDirectionBOGrandTotal = 0;
      this.budgetImportBO.representativeContacts = [];
      this.budgetImportBO.representativeContacts.push(new RepresentativeContactsBO())
      this.bind_ContactData = []
      this.bind_ContactData.push(new ClientContactInfoBO())
      this.budgetImportBO.additionalContactsBo = [];
      this.budgetImportBO.additionalContactsBo.push(new RepresentativeContactsBO())
      this.bind_AdditionalContactData = []
      this.bind_AdditionalContactData.push(new ClientContactInfoBO())
      this.budgetImportBO.personalAssistance = [];
      this.budgetImportBO.personalAssistance.push(new AuthBo())

      this.budgetImportBO.goalstable = [];

      this.budgetImportBO.goalstable.push(new Goals())
      let go = new Goals()
      go.goalType = "Personal Assistance"
      this.persoanlAssisGoal.push(go)
      let go1 = new Goals()
      go1.goalType = "Environmental"
      this.EnvironmentalGoal.push(go1)
      let go2 = new Goals()
      go2.goalType = "Treatment"
      this.TreatmentGoal.push(go2)
      let go3 = new Goals()
      go3.goalType = "Self"
      this.SelfServiceGoal.push(go3)
      this.budgetImportBO.personalAssistanceGoods = [];
      this.budgetImportBO.personalAssistanceGoods.push(new AuthBo())


      this.budgetImportBO.scheduleBOsp = [];
      this.budgetImportBO.scheduleBOsp.push(new ScheduleBO())
      this.budgetImportBO.treatmentTraining = [];
      this.budgetImportBO.treatmentTraining.push(new AuthBo())

      this.budgetImportBO.treatmentTrainingGoods = [];
      this.budgetImportBO.treatmentTrainingGoods.push(new AuthBo())

      this.budgetImportBO.environmentalMods = [];
      this.budgetImportBO.environmentalMods.push(new AuthBo())

      this.budgetImportBO.environmentalModsGoods = [];
      this.budgetImportBO.environmentalModsGoods.push(new AuthBo())
      this.budgetImportBO.selfDirectionBO = [];
      this.budgetImportBO.selfDirectionBO.push(new AuthBo())

      this.budgetImportBO.budgetHealthandSafetyMonitors = [];
      this.budgetImportBO.budgetHealthandSafetyMonitors.push(new BudgetHealthandSafetyMonitors())


      this.budgetImportBO.budgetExpendituresMonitor = [];
      this.budgetImportBO.budgetExpendituresMonitor.push(new BudgetExpendituresMonitorBO())

     
      this.budgetImportBO.budgetEvaluationOfLastYearPlansBO = [];
      this.budgetImportBO.budgetEvaluationOfLastYearPlansBO.push(new BudgetEvaluationOfLastYearPlansBO())
   }
    else {
      this.budgetImportBO.personalAssistanceGrandTotal = 0;

      this.budgetImportBO.treatmentTrainingGrandTotal = 0;

      this.budgetImportBO.environmentalModsGrandTotal = 0;

      this.budgetImportBO.selfDirectionBOGrandTotal = 0;

      // Production Issue For Enable Budget Field Editable
      // this.budgetform.get('date1').disable();     
      // this.budgetform.get('date2').disable();

      this.getClientContact(this.budgetImportBO.clientId)
      if (this.budgetImportBO.personalAssistance.length == 0) {
        let Contact = new AuthBo();
        this.budgetImportBO.personalAssistance.push(Contact);
      } else{
        this.budgetImportBO.personalAssistance.forEach(element => {
          this.calculatetotalAmt(element,"personalAssistance") 
        });
      }
      if (this.budgetImportBO.treatmentTraining.length == 0) {
        let Contact1 = new AuthBo();
        this.budgetImportBO.treatmentTraining.push(Contact1);
      }
      else{
        this.budgetImportBO.treatmentTraining.forEach(element => {
          this.calculatetotalAmt(element,"TreatmentTraining") 
        });
      }
      if (this.budgetImportBO.environmentalMods.length == 0) {
        let Contact2 = new AuthBo();
        this.budgetImportBO.environmentalMods.push(Contact2);
      }else{
        this.budgetImportBO.environmentalMods.forEach(element => {
          this.calculatetotalAmt(element,"Environmental") 
        });
      }
      if (this.budgetImportBO.personalAssistanceGoods.length == 0) {
        let Contact = new AuthBo();
        this.budgetImportBO.personalAssistanceGoods.push(Contact);
      }
      else{
        this.budgetImportBO.personalAssistanceGoods.forEach(element => {
          this.calculatetotalAmt(element,"personalAssistance") 
        });
      }
      if (this.budgetImportBO.treatmentTrainingGoods.length == 0) {
        let Contact1 = new AuthBo();
        this.budgetImportBO.treatmentTrainingGoods.push(Contact1);
      }
      else{
        this.budgetImportBO.treatmentTrainingGoods.forEach(element => {
          this.calculatetotalAmt(element,"TreatmentTraining") 
        });
      }
      if (this.budgetImportBO.environmentalModsGoods.length == 0) {
        let Contact2 = new AuthBo();
        this.budgetImportBO.environmentalModsGoods.push(Contact2);
      }else{
        this.budgetImportBO.environmentalModsGoods.forEach(element => {
          this.calculatetotalAmt(element,"Environmental") 
        });
      }
      if (this.budgetImportBO.selfDirectionBO.length == 0) {
        let Contact3 = new AuthBo();
        this.budgetImportBO.selfDirectionBO.push(Contact3);
      }else{
        this.budgetImportBO.selfDirectionBO.forEach(element => {
          this.calculatetotalAmt(element,"self") 
        });
      }
      if (this.budgetImportBO.scheduleBOsp.length == 0) {
        this.budgetImportBO.scheduleBOsp = [];
        this.budgetImportBO.scheduleBOsp.push(new ScheduleBO())
      }

      if (this.budgetImportBO.representativeContacts.length == 0) {
        this.budgetImportBO.representativeContacts = [];
        this.budgetImportBO.representativeContacts.push(new RepresentativeContactsBO())
      }
      else {
        this.budgetImportBO.representativeContacts.forEach(element => {
          element.phoneNumber = (element.phoneNumber != null && element.phoneNumber != undefined) ? this.general.converPhoneGoogleLib(element.phoneNumber) : null;
          element.alternatePhoneNumber = (element.alternatePhoneNumber != null && element.alternatePhoneNumber != undefined) ? this.general.converPhoneGoogleLib(element.alternatePhoneNumber) : null;

        });

      }

      if (this.budgetImportBO.additionalContactsBo.length == 0) {
        this.budgetImportBO.additionalContactsBo = [];
        this.budgetImportBO.additionalContactsBo.push(new RepresentativeContactsBO())
      }
      else {
        this.budgetImportBO.additionalContactsBo.forEach(element => {
          element.phoneNumber = (element.phoneNumber != null && element.phoneNumber != undefined) ? this.general.converPhoneGoogleLib(element.phoneNumber) : null;
          element.alternatePhoneNumber = (element.alternatePhoneNumber != null && element.alternatePhoneNumber != undefined) ? this.general.converPhoneGoogleLib(element.alternatePhoneNumber) : null;

        });

      }
      if (this.budgetImportBO.goalstable.length == 0) {
        this.budgetImportBO.goalstable = [];

        this.budgetImportBO.goalstable.push(new Goals())
        let go = new Goals()
        go.goalType = "Personal Assistance"
        this.persoanlAssisGoal.push(go)
        let go1 = new Goals()
        go1.goalType = "Environmental"
        this.EnvironmentalGoal.push(go1)
        let go2 = new Goals()
        go2.goalType = "Treatment"
        this.TreatmentGoal.push(go2)
        let go3 = new Goals()
        go3.goalType = "Self"
        this.SelfServiceGoal.push(go3)
      }
      else {
        this.persoanlAssisGoal = this.budgetImportBO.goalstable.filter(g => g.goalType == 'Personal Assistance')
        this.EnvironmentalGoal = this.budgetImportBO.goalstable.filter(g => g.goalType == 'Environmental')
        this.TreatmentGoal = this.budgetImportBO.goalstable.filter(g => g.goalType == 'Treatment')
        this.SelfServiceGoal = this.budgetImportBO.goalstable.filter(g => g.goalType == 'Self')
      }
      if (this.budgetImportBO.hospitalContactId != null && this.budgetImportBO.hospitalContactId != '') {
        setTimeout(() => {
          this.bind_HospitalDetails(this.budgetImportBO.hospitalContactId)
        }, 5000);

      }
      if (this.budgetImportBO.schoolContactId != null && this.budgetImportBO.schoolContactId != '') {
        setTimeout(() => {
          this.bind_SchoolDetails(this.budgetImportBO.schoolContactId)
        }, 5000);

      }
      if (this.budgetImportBO.doctorContactId != null && this.budgetImportBO.doctorContactId != '') {
        setTimeout(() => {
          this.bind_DoctorDetails(this.budgetImportBO.doctorContactId)
        }, 5000);

      }

      if (this.budgetImportBO.supportPlannerId != null && this.budgetImportBO.supportPlannerId != '') {
        setTimeout(() => {
          this.bind_SupportManager(this.budgetImportBO.supportPlannerId)
        }, 5000);

      }
      if (this.budgetImportBO.casemanagerId != null && this.budgetImportBO.casemanagerId != '') {
        setTimeout(() => {
          this.bind_CaseManager(this.budgetImportBO.casemanagerId)
        }, 5000);

      }
      if (this.budgetImportBO.budgetExpendituresMonitor.length == 0) {
        let Contact3 = new BudgetExpendituresMonitorBO();
        this.budgetImportBO.budgetExpendituresMonitor.push(Contact3);
      }

      if (this.budgetImportBO.budgetHealthandSafetyMonitors.length == 0) {
        let Contact3 = new BudgetHealthandSafetyMonitors();
        this.budgetImportBO.budgetHealthandSafetyMonitors.push(Contact3);
      }
      //   if(this.budgetImportBO.personalAssistance.goal.length==0){
      //     let i = new goalBO();
      //     this.budgetImportBO.personalAssistance.goal.push(i);
      //   }
      //   if(this.budgetImportBO.treatmentAndTraining.goal.length==0){
      //     let i = new goalBO();
      //     this.budgetImportBO.treatmentAndTraining.goal.push(i);
      //   }
      //   if(this.budgetImportBO.environmentalModificationAndProvisions.goal.length==0){
      //     let i = new goalBO();
      //     this.budgetImportBO.environmentalModificationAndProvisions.goal.push(i);
      //   }
      //   if(this.budgetImportBO.evaluationOfLastYearPlan.length==0){
      //     let goal1 = new EvaluationOfLastYearPlanBO();
      //     this.budgetImportBO.evaluationOfLastYearPlan.push(goal1);
      //   }
      //   if(this.budgetImportBO.personalAssistance.schduleWeeks.length==0){
      //     let schdule = new SchduleWeekBo();
      //     this.budgetImportBO.personalAssistance.schduleWeeks.push(schdule);
      //   }
      //   if(this.budgetImportBO.parentOrLegalRepresentativeOrManagingParty.length==0){
      //     let list = new ParentOrLegalRepresentativeOrManagingPartyBO();
      //     this.budgetImportBO.parentOrLegalRepresentativeOrManagingParty.push(list);
      //   }
      //   if(this.budgetImportBO.additionalContact.additionalAddress.length==0){
      //     let con = new AdditionalAddress();
      // this.budgetImportBO.additionalContact.additionalAddress.push(con);
      //   }


    }
    setTimeout(() => {
      document.getElementById('openModal').click();
    }, 4000);



    if (this.budgetImprtPlan != null && this.budgetImprtPlan != undefined) {
      

      this.budgetImportBO = this.budgetImprtPlan;
   
      this.budgetImportBO.clientId=this.budgetImprtPlan.clientId
      
      this.value=(this.budgetImportBO.budgetAmt!=null&&this.budgetImportBO.budgetAmt!=undefined&&this.total!=null&&this.total!=undefined)?Number((this.budgetImportBO.budgetAmt - this.total) .toFixed(4)):0

      this.validform1.controls['date'].setValue(this.budgetImprtPlan.budgetdate)
      // this.validform1.controls['persondate'].setValue(this.budgetImprtPlan.personRecevingServices.dob)
      this.bind_ClientValues(this.budgetImprtPlan.clientId)
      this.getClientContact(this.budgetImprtPlan.clientId)


      
      this.budgetImportBO.whatwillDoInCaseDate = this.datepipe.transform(this.budgetImportBO.whatwillDoInCaseDate, "MM/dd/yyyy")
      this.budgetImportBO.healthandSafetyPlanDate = this.datepipe.transform(this.budgetImportBO.healthandSafetyPlanDate, "MM/dd/yyyy")
      this.budgetImportBO.budgetStartDate = this.datepipe.transform(this.budgetImportBO.budgetStartDate, "MM/dd/yyyy")
      this.budgetImportBO.budgetEndDate = this.datepipe.transform(this.budgetImportBO.budgetEndDate, "MM/dd/yyyy")
      this.budgetImportBO.budgetdate = this.datepipe.transform(this.budgetImportBO.budgetdate, "MM/dd/yyyy")
      // this.budgetImportBO.personRecevingServices.dob=this.datepipe.transform(this.budgetImportBO.personRecevingServices.dob,"MM/dd/yyyy")


      this.budgetform.get('date1').setValue(this.budgetImportBO.budgetStartDate);
      
      this.budgetform.get('date2').setValue(this.budgetImportBO.budgetEndDate);


      if (this.budgetImportBO.clientId != '00000000-0000-0000-0000-000000000000' && this.budgetImportBO.clientId != null &&
        this.budgetImportBO.clientId != undefined) {
        this.budgetform.controls["client"].disable()
      }
     

    }



  }

  ngOnChanges() {

    if (this.budgetPlan.id != null && this.budgetPlan.id != undefined) {
      if (this.budgetImprtPlan != null) {
   
        this.budgetImportBO = this.budgetImprtPlan;
        this.validform1.controls['date'].setValue(this.budgetImprtPlan.budgetdate)
        
      }

    }

  }
  public staffingList = []
  public schlst = []
  public anuallst = []
  public schlst1 = []
  public emplst = [];
  public planlst = [];
  public budgetlst = [];
  public fiscalst = [];
  DemographicPhoneFormat_3(value) {
    if(value == 'phone'){
    this.Case.phone = this.general.converPhoneGoogleLib(this.Case.phone);
  }
  if(value == 'fax'){
    this.Case.fax = this.general.converPhoneGoogleLib(this.Case.fax);
  }
}
DemographicPhoneFormat_4(value) {
  if(value == 'phone'){
  this.support.phone = this.general.converPhoneGoogleLib(this.Case.phone);
}
if(value == 'fax'){
  this.support.fax = this.general.converPhoneGoogleLib(this.Case.fax);
}
}
  getstaffing() {
    if (this.global.LoginEntityType == 'ADMIN') {
      let params = new URLSearchParams();
      params.append("ListCode", "YESORNO");
      this.budgetService.gettype(params).subscribe((data: any) => {
        this.staffingList = data;
        this.staffingList.forEach(element => {
          element.Key = element.Key;
        });
      })


    }
    else {
      let params = new URLSearchParams();
      params.append("ListCode", "YESORNO");
      this.budgetService.getcommon(params).subscribe((data: any) => {
        this.staffingList = data;
        this.staffingList.forEach(element => {
          element.Key = element.Key;
        });
      })

    }


  }
  getannual() {
    if (this.global.LoginEntityType == 'ADMIN') {
      let params = new URLSearchParams();
      params.append("ListCode", "TYPEOFWAIVER");
      this.budgetService.gettype(params).subscribe((data: any) => {
        this.anuallst = data;


        this.staffingList.forEach(element => {
          element.Key = element.Key;
        });
      })
    }
    else {

      let params = new URLSearchParams();
      params.append("ListCode", "TYPEOFWAIVER");
      this.budgetService.getcommon(params).subscribe((data: any) => {
        this.anuallst = data;


        this.staffingList.forEach(element => {
          element.Key = element.Key;
        });
      })

    }
  }

  getschudule() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD') {
      let params = new URLSearchParams();
      params.append("Code", "SCHDULEBUDGET");
      this.budgetService.gettype(params).subscribe((data: any) => {
        this.schlst = data;
        this.schlst.forEach(element => {
          element.Key = element.Key;


        });
      })
    }
    else {
      let params = new URLSearchParams();
      params.append("Code", "SCHDULEBUDGET");
      this.budgetService.getcommon(params).subscribe((data: any) => {
        this.schlst = data;
        this.schlst.forEach(element => {
          element.Key = element.Key;


        });
      })

    }

  }
  getschudule1() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD') {
      let params = new URLSearchParams();
      params.append("Code", "SCHDULEBUDGET");
      this.budgetService.gettype(params).subscribe((data: any) => {
        this.schlst1 = data;
        this.schlst1.forEach(element => {
          element.Key = element.Key;


        });
      })
    }
    else {
      let params = new URLSearchParams();
      params.append("Code", "SCHDULEBUDGET");
      this.budgetService.getcommon(params).subscribe((data: any) => {
        this.schlst1 = data;
        this.schlst1.forEach(element => {
          element.Key = element.Key;


        });
      })
    }

  }
  getemp() {
    if (this.global.LoginEntityType == 'ADMIN') {
      let params = new URLSearchParams();
      params.append("ListCode", "EMPLOYMENTMODEL");
      this.budgetService.gettype(params).subscribe((data: any) => {
        this.emplst = data;


        this.emplst.forEach(element => {
          element.Key = element.Key;


        });
      })
    }
    else {
      let params = new URLSearchParams();
      params.append("ListCode", "EMPLOYMENTMODEL");
      this.budgetService.getcommon(params).subscribe((data: any) => {
        this.emplst = data;


        this.emplst.forEach(element => {
          element.Key = element.Key;


        });
      })
    }

  }
  getplan() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD') {
      let params = new URLSearchParams();
      params.append("ListCode", "NEXTYEARPLAN");
      this.budgetService.gettype(params).subscribe((data: any) => {
        this.planlst = data;
        this.planlst.forEach(element => {
          element.Key = element.Key;


        });
      })
    }
    else {
      let params = new URLSearchParams();
      params.append("Code", "NEXTYEARPLAN");
      this.budgetService.getcommon(params).subscribe((data: any) => {
        this.planlst = data;
        this.planlst.forEach(element => {
          element.Key = element.Key;


        });
      })
    }

  }

  getbudget() {
    if (this.global.LoginEntityType == 'ADMIN') {
      let params = new URLSearchParams();
      params.append("listCode", "BUDGETIMPORTTYPE");
      this.budgetService.gettype(params).subscribe((data: any) => {
        this.budgetlst = data;
        this.budgetlst.forEach(element => {
          element.Key = element.Key;


        });
      })
    }
    else {
      let params = new URLSearchParams();
      params.append("listCode", "BUDGETIMPORTTYPE");
      this.budgetService.getcommon(params).subscribe((data: any) => {
        this.budgetlst = data;
        this.budgetlst.forEach(element => {
          element.Key = element.Key;


        });
      })
    }

  }
  getfiscal() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD') {
      let params = new URLSearchParams();
      params.append("Code", "FISCALSUPPORTENTITYSTAFF");
      this.budgetService.gettype(params).subscribe((data: any) => {
        this.fiscalst = data;
        this.fiscalst.forEach(element => {
          element.Key = element.Key;


        });
      })
    }
    else {


      let params = new URLSearchParams();
      params.append("Code", "FISCALSUPPORTENTITYSTAFF");
      this.budgetService.getcommon(params).subscribe((data: any) => {
        this.fiscalst = data;
        this.fiscalst.forEach(element => {
          element.Key = element.Key;


        });
      })
    }

  }
  ContactDetails: Array<ClientContactInfoBO> = []
  getClientContact(ClientId) {

    let params = new URLSearchParams();
    params.append("ClientId", ClientId);


    if (this.global.LoginUserType.toUpperCase() == 'ONBOARD') {
      this.budgetService.getClientContactOnboard(params).subscribe((data: any) => {
        this.ContactDetails = data
      })

    } else {
      this.budgetService.getClientContact(params).subscribe((data: any) => {
        this.ContactDetails = data
      })
    }



  }
  contactId: any

  bind_ContactDetails(id, index, Bo: RepresentativeContactsBO) {
    if (Bo.contactId != null) {
      let contactdata = this.ContactDetails.filter(e => e.id == id)[0]
      
      Bo.street = contactdata.street;
      Bo.email = contactdata.email;
      Bo.city = contactdata.city;
      Bo.clinic = contactdata.clinic;
      Bo.state = contactdata.state;
      Bo.zipCode = contactdata.zipCode;
      Bo.county = contactdata.county;
      Bo.phoneNumber = (contactdata.phoneNumber != null && contactdata.phoneNumber != undefined) ? this.general.converPhoneGoogleLib(contactdata.phoneNumber) : null;
      Bo.alternatePhoneNumber = (contactdata.alternatePhoneNumber != null && contactdata.alternatePhoneNumber != undefined) ? this.general.converPhoneGoogleLib(contactdata.alternatePhoneNumber) : null;

    }
    else {
      Bo = new RepresentativeContactsBO();
    }
    // this.bind_ContactData[index] = this.ContactDetails.filter(e => e.id == id)[0]

  }
  bind_AdditionalContactDetails(id, index, Bo: RepresentativeContactsBO) {
    // this.bind_AdditionalContactData[index] = this.ContactDetails.filter(e => e.id == id)[0]
    if (Bo.contactId != null) {
      let contactdata = this.ContactDetails.filter(e => e.id == id)[0]
      Bo.street = contactdata.street;
      Bo.city = contactdata.city;
      Bo.state = contactdata.state;
      Bo.zipCode = contactdata.zipCode;
      Bo.county = contactdata.county;
      Bo.phoneNumber = (contactdata.phoneNumber != null && contactdata.phoneNumber != undefined) ? this.general.converPhoneGoogleLib(contactdata.phoneNumber) : null;
      Bo.alternatePhoneNumber = (contactdata.alternatePhoneNumber != null && contactdata.alternatePhoneNumber != undefined) ? this.general.converPhoneGoogleLib(contactdata.alternatePhoneNumber) : null;


    }
    else {
      Bo = new RepresentativeContactsBO();
    }


  }
  HospitalDetails: ClientContactInfoBO = new ClientContactInfoBO()

  bind_HospitalDetails(id) {
    let data = this.ContactDetails.filter(e => e.id == id);
    if (data.length != 0) {
      this.HospitalDetails = data[0]
      this.HospitalDetails.phoneNumber = (this.HospitalDetails.phoneNumber != null && this.HospitalDetails.phoneNumber != undefined) ? this.general.converPhoneGoogleLib(this.HospitalDetails.phoneNumber) : null;
      this.HospitalDetails.alternatePhoneNumber = (this.HospitalDetails.phoneNumber != null && this.HospitalDetails.phoneNumber != undefined) ? this.general.converPhoneGoogleLib(this.HospitalDetails.alternatePhoneNumber) : null;
      //
    } else {
      this.HospitalDetails = new ClientContactInfoBO();
    }

  }
  DoctorDetails: ClientContactInfoBO = new ClientContactInfoBO()

  bind_DoctorDetails(id) {
    let data = this.ContactDetails.filter(e => e.id == id)
    if (data.length != 0) {
      this.DoctorDetails = data[0]
      this.DoctorDetails.phoneNumber = (this.DoctorDetails.phoneNumber != null && this.DoctorDetails.phoneNumber != undefined) ? this.general.converPhoneGoogleLib(this.DoctorDetails.phoneNumber) : null;
      this.DoctorDetails.alternatePhoneNumber = (this.DoctorDetails.phoneNumber != null && this.DoctorDetails.phoneNumber != undefined) ? this.general.converPhoneGoogleLib(this.DoctorDetails.alternatePhoneNumber) : null;

    } else {
      this.DoctorDetails = new ClientContactInfoBO();
    }
  }
  SchoolDetails: ClientContactInfoBO = new ClientContactInfoBO()

  bind_SchoolDetails(id) {
    let data = this.ContactDetails.filter(e => e.id == id)
    if (data.length != 0) {
      this.SchoolDetails = data[0]
      this.SchoolDetails.phoneNumber = (this.SchoolDetails.phoneNumber != null && this.SchoolDetails.phoneNumber != undefined) ? this.general.converPhoneGoogleLib(this.SchoolDetails.phoneNumber) : null;
      this.SchoolDetails.alternatePhoneNumber = (this.SchoolDetails.phoneNumber != null && this.SchoolDetails.phoneNumber != undefined) ? this.general.converPhoneGoogleLib(this.SchoolDetails.alternatePhoneNumber) : null;

    } else {
      this.SchoolDetails = new ClientContactInfoBO();
    }
  }


  goalColumn: boolean = false;




  closeFun() {
    document.getElementById('openModal').click();
    this.budgetPlan.edit = false;
    this.BudgetView.isabasicadvance = false;
   
    

    this.dataEmitFromCDCSPlan.emit(this.budgetPlan);


  }

  ContactColumn: boolean = false;

  CreateBudgetExpendituresMonitor(i) {



    let list = new BudgetExpendituresMonitorBO();
    this.budgetImportBO.budgetExpendituresMonitor.push(list);
  }
  removeBudgetExpendituresMonitor(Contact, BO) {
    if (BO.id == '00000000-0000-0000-0000-000000000000') {
      this.budgetImportBO.budgetExpendituresMonitor.splice(Contact, 1);

    } else {
      this.budgetImportBO.budgetExpendituresMonitor.splice(Contact, 1);
      let params = new URLSearchParams()
      params.append("Id", BO.id)
      this.budgetService.deleteBudegtExpenditure(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

        if (data) {
          this.toastrService.success("Deleted Successfully")
        }



      }, (err: HttpErrorResponse) => {


      })
    }



  }
  CreateBudgetHealthandSafetyMonitors(i) {



    let list = new BudgetHealthandSafetyMonitors();
    this.budgetImportBO.budgetHealthandSafetyMonitors.push(list);
  }
  removeBudgetHealthandSafetyMonitors(Contact, BO) {
    if (BO.id == '00000000-0000-0000-0000-000000000000') {
      this.budgetImportBO.budgetHealthandSafetyMonitors.splice(Contact, 1);

    } else {
      this.budgetImportBO.budgetHealthandSafetyMonitors.splice(Contact, 1);
      let params = new URLSearchParams()
      params.append("Id", BO.id)
      this.budgetService.deleteBudegtHealthSafetyMonitors(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

        if (data) {
          this.toastrService.success("Deleted Successfully")
        }



      }, (err: HttpErrorResponse) => {


      })
    }




  }
  Createweek(i) {
    // if (this.budgetImportBO.personalAssistance.schduleWeeks.length > 0) {
    //   this.ContactColumn = true;
    //   this.budgetImportBO.personalAssistance.schduleWeeks[i].isadd7=true

    // }


    let list = new ScheduleBO();
    this.budgetImportBO.scheduleBOsp.push(list);
  }
  removeweek(Contact) {

    this.budgetImportBO.scheduleBOsp.splice(Contact, 1);
    // if(this.budgetImportBO.scheduleBOsp.length==1){
    //   this.budgetImportBO.personalAssistance.schduleWeeks[0].isadd7=false
    // }

  }
  CreateEvalue(i) {
    if (this.budgetImportBO.budgetEvaluationOfLastYearPlansBO.length > 0) {
      this.ContactColumn = true;
      // this.budgetImportBO.budgetEvaluationOfLastYearPlansBO[i].isadd8=true
      // let list1 = new BudgetEvaluationOfLastYearPlansBO();
      //  this.budgetImportBO.budgetEvaluationOfLastYearPlansBO.push(list1)


    }
    let list = new BudgetEvaluationOfLastYearPlansBO();
    this.budgetImportBO.budgetEvaluationOfLastYearPlansBO.push(list);


  }
  removeSelectEvalue(Contact, BO) {

    if (BO.id == '00000000-0000-0000-0000-000000000000') {
      this.budgetImportBO.budgetEvaluationOfLastYearPlansBO.splice(Contact, 1);

    } else {
      this.budgetImportBO.budgetEvaluationOfLastYearPlansBO.splice(Contact, 1);
      let params = new URLSearchParams();
      params.append("Id", BO.id);
      this.budgetService.deleteEvaluationLastYearPlan(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

        if (data) {
          this.toastrService.success("Deleted Successfully")
        }



      }, (err: HttpErrorResponse) => {


      })
    }
    // if(this.budgetImportBO.evaluationOfLastYearPlan.length==1){
    //   this.budgetImportBO.evaluationOfLastYearPlan[0].isadd8=false
    // }

  }



  drawStartsign(value) {


    // will be notified of szimek/signature_pad's onBegin event
  }

  sign: string = '';
  sign1: string = '';
  drawComplete(value) {

    if (value == 'recipient') {
      this.receipentSign = this.recipientsignaturePad.toDataURL()
    }
    if (value == 'parent') {
      this.parentSign = this.parentsignaturePad1.toDataURL()
    }
    if (value == 'lead1') {
      this.leadAgencySign1 = this.leadAgencysignaturePad1.toDataURL()
    }
    if (value == 'lead2') {
      this.leadAgencySign2 = this.leadAgencysignaturePad2.toDataURL()
    }
    // // will be notified of szimek/signature_pad's onEnd event
    // this.sign1 = this.parentsignaturePad1.toDataURL();
    // this.dynamicdata.PLAN_OF_CARE_REVIEW_UPDATE_MINIMALLY_ANNUALLY.value.forEach(element => {
    //   if (element.label == 'Nurse sign') {
    //     element.value = this.sign1;
    //   }
    // });
  }

  clearnursesign() {
    this.recipientsignaturePad.clear();
    this.receipentSign = '';
  }
  clearnursesign1() {
    this.parentsignaturePad1.clear();
    this.parentSign = '';
  }
  clearnursesign2() {
    this.leadAgencysignaturePad1.clear();
    this.leadAgencySign1 = '';
  }

  // clearnursesign() {

  //   // this.signaturePad1.clear();
  //   // this.sign1 = '';
  //   // this.dynamicdata.PLAN_OF_CARE_REVIEW_UPDATE_MINIMALLY_ANNUALLY.value.forEach(element => {
  //   //   if (element.label == 'Nurse sign') {
  //   //     element.value = this.sign1;
  //   //   }
  //   // });
  // }
  allClientDropDown: any;
  ClientEmpList: any = [];
  ClinetDropDown: any;

  // getAllClientDropDown() {
  //   if(this.global.LoginUserType.toUpperCase() != 'ONBOARD'){
  //     let params = new URLSearchParams();
  //    params.append("LocationId", this.locationLid);


  //   this.budgetService.GetAllClientsDropDownbyAgency(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
  //     this.allClientDropDown = data;
  //     this.allClientDropDown.forEach(e => {
  //       e.id = e.id;
  //     });
  //     this.ClinetDropDown = this.allClientDropDown.filter(e => e.status == "ACTIVE");
  //     if(this.budgetPlan.clientId!="00000000-0000-0000-0000-000000000000")
  //   {
  //     this.budgetImportBO.clientId=this.budgetPlan.clientId;


  //   }
  //   });

  //   }
  //   else{
  //     let params = new URLSearchParams();
  //     params.append("LocationId", this.locationLid);


  //     this.budgetService.GetAllClientsDropDownby(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
  //       this.allClientDropDown = data;
  //       this.allClientDropDown.forEach(e => {
  //         e.id = e.id;
  //       });
  //       this.ClinetDropDown = this.allClientDropDown.filter(e => e.status == "ACTIVE");
  //       if(this.budgetPlan.clientId!="00000000-0000-0000-0000-000000000000")
  //     {
  //       this.budgetImportBO.clientId=this.budgetPlan.clientId;


  //     }
  //     });
  //   }


  // }
  caseManagerName: any
  showCaseManager: CaseManagerBO = new CaseManagerBO()
  bind_CaseManager(val) {
    let data = this.CaseManagerDetails.filter(e => e.id == val)
    if (data.length != 0) {
      this.showCaseManager = data[0]
    } else {
      this.showCaseManager = new CaseManagerBO();
    }



  }
  showSupportManager: SupportPlannerDetailsBO = new SupportPlannerDetailsBO()
  supportManagerName: any
  bind_SupportManager(val) {
    let data = this.SupportPlannerDetails.filter(e => e.id == val)
    if (data.length != 0) {
      this.showSupportManager = data[0]
    } else {
      this.showSupportManager = new SupportPlannerDetailsBO();
    }


  }

  // getAllClientDropDown() {


  //   this.budgetService.GetAllClientForAgency().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
  //     this.allClientDropDown = data;
  //     // this.budgetImportBO.clientId
  //     // this.budgetImportBO.clientId =this.allClientDropDown.filter(e=> e.id == this.global.clientId)[0].id


  //     if (this.budgetImportBO.clientId != '00000000-0000-0000-0000-000000000000' && this.budgetImportBO.clientId != null && this.budgetImportBO.clientId != undefined) {


  //     }
  //     // this.allClientDropDown.forEach(e => {
  //     //   e.id = e.id;
  //     // });
  //     // this.ClinetDropDown = this.allClientDropDown.filter(e => e.status == "ACTIVE");


  //     //   if(this.filter.clientId!="00000000-0000-0000-0000-000000000000")
  //     // {
  //     //   // this.budgetImportBO.clientId=this.filter.clientId;


  //     // }
  //   });

  // }
  companyList:any
  GetCompanyNameDropdown() {
    if (this.global.LoginEntityType == 'ADMIN') {
      this.budgetService.getCompanyDropDown().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.companyList = data;
      }, (err: any) => {
        if (err) {
          this.toastrService.error(err, 'Error'), 8000;
        }
      })

    } else {
     
      this.budgetService.getCompanyDropDownForOnboard().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.companyList = data;
      }, (err: any) => {
        if (err) {
          this.toastrService.error(err, 'Error'), 8000;
        }
      })
    }
   
  
  }
  AgencyDetails: AgencyDetails = new AgencyDetails()
  getAgencyetails() {
    if(this.global.LoginEntityType == 'ADMIN') {
      this.budgetService.GetAgencyDetails().pipe(takeUntil(this.onDestroy$)).subscribe((data: AgencyDetails) => {
        this.AgencyDetails = data;
  
  
  
  
      });
    } else {
     

      this.budgetService.GetAgencyDetailsForOnboard().pipe(takeUntil(this.onDestroy$)).subscribe((data: AgencyDetails) => {
        this.AgencyDetails = data;
  
  
  
  
      });
  

    }

   
  }
  CaseManagerDetails: Array<CaseManagerBO> = []
  getCaseManagerDetails() {
    if (this.global.LoginEntityType == 'ADMIN') {
      this.budgetService.GetCaseManager().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.CaseManagerDetails = data;




      });

    } else {
    

      this.budgetService.GetCaseManagerOnboard().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.CaseManagerDetails = data;




      });
    }


  }
  SupportPlannerDetails: Array<SupportPlannerDetailsBO> = []
  getSupportPlannerDetails() {
    if (this.global.LoginEntityType == 'ADMIN') {
      this.budgetService.GetSupportPlanner().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.SupportPlannerDetails = data;




      });
    } else {
     
      this.budgetService.GetSupportPlannerOnboard().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.SupportPlannerDetails = data;




      });
    }


  }
  start: string;
  end: string;
  editDate: string;
  check_changee(data, val) {
    this.budgetImportBO.personalAssistance[val].doesPtoApply = data.target.checked;



  }
  check_change(data, val) {

    this.budgetImportBO.personalAssistance[val].payrollTaxApply = data.target.checked


  }
  check_change1(data, val) {
    this.budgetImportBO.treatmentTraining[val].doesPtoApply = data.target.checked;



  }
  check_change2(data, val) {

    this.budgetImportBO.treatmentTraining[val].payrollTaxApply = data.target.checked


  }
  check_change3(data) {
    // budgetImportBO.selfDirectionSupportActivities.annualBudgetBO.monitor.month
    // this.budgetImportBO.selfDirectionSupportActivities.annualBudgetBO.monitor.fiscalSupportEntityStaff = data.target.checked;


  }
  // check_change4(data) {

  //   this.budgetImportBO.selfDirectionSupportActivities.annualBudgetBO.monitor.FiscalSupportEntityStaff=data.target.checked

  // }
  // check_change2(data,val) {
  //   this.budgetImportBO.environmentalModificationAndProvisions.serviceAssistance[val].doesPTOApply=data.target.checked;
  //   this.budgetImportBO.environmentalModificationAndProvisions.serviceAssistance[val].doPayrollTaxApply=data.target.checked

  // }
  // check_change3(data,val) {
  //   this.budgetImportBO.selfDirectionSupportActivities.serviceAssistance[val].doesPTOApply=data.target.checked;
  //   this.budgetImportBO.selfDirectionSupportActivities.serviceAssistance[val].doPayrollTaxApply=data.target.checked


  // }
  newdates(event, type, name) {
    if (type == "inputchage") {
      if (name == 'startDate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.budgetImportBO.budgetStartDate = val1;

        }
      }

      if (name == 'endDate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.budgetImportBO.budgetEndDate = val1;
        }
      }


      if (name == 'budgetdate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.budgetImportBO.budgetdate = val1;
        }
      }

      if (name == 'healthandSafetyPlanDate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.budgetImportBO.healthandSafetyPlanDate = val1;

        }


      }
      if (name == 'dOB') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          // this.budgetImportBO.personRecevingServices.dob= val1;
        }
      }


      if (name == 'whatwillDoInCaseDate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.budgetImportBO.whatwillDoInCaseDate = val1;
        }
      }





    }

    if (type == "datechagned") {
      if (name == 'startDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.budgetImportBO.budgetStartDate = val1;
        }
      }

      if (name == 'endDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.budgetImportBO.budgetEndDate = val1;
        }
      }
      if (name == 'healthandSafetyPlanDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.budgetImportBO.healthandSafetyPlanDate = val1;
        }
      }
      if (name == 'budgetdate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.budgetImportBO.budgetdate = val1;


        }
      }
      if (name == 'dOB') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          // this.budgetImportBO.personRecevingServices.dob= val1;
        }
      }

      if (name == 'whatwillDoInCaseDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event)
          this.budgetImportBO.whatwillDoInCaseDate = val1;
        }
      }





    }
  }
  fun_1(val) {


    // this.budgetImportBO.selfDirectionSupportActivities.annualBudgetBO.monitor.fiscalSupportEntityStaff = val.target.checked;


  }


  budgetErrorList: any = [];
  add() {

    let budget = JSON.parse(JSON.stringify(this.budgetImportBO));

    budget.selfDirectionSupportActivities.annualBudgetBO.monitor.healthandSafetyPlanBO.receipientSign = this.receipentSign;
    budget.selfDirectionSupportActivities.annualBudgetBO.monitor.healthandSafetyPlanBO.parent_Legal_Representative_Managing_Party_Sign = this.parentSign;
    budget.selfDirectionSupportActivities.annualBudgetBO.monitor.healthandSafetyPlanBO.lead_Agency_Representative_Care_Manager_Sign = this.leadAgencySign1;

    budget.budgetAmt = (budget.budgetAmt != null && budget.budgetAmt != undefined) ? parseFloat(budget.budgetAmt) : null;
    if (budget.personalAssistance.serviceAssistances.length > 0) {
      if (budget.personalAssistance.serviceAssistances.length == 1 && budget.personalAssistance.serviceAssistances[0].payorName == null && budget.personalAssistance.serviceAssistances[0].groupPayorServiceId == null) {
        budget.personalAssistance.serviceAssistances = [];
      }
      else {
        budget.personalAssistance.serviceAssistances.forEach(i => {
          i.rate = (i.rate != null && i.rate != undefined) ? parseFloat(i.rate) : null;
          i.hours = (i.hours != null && i.hours != undefined) ? parseInt(i.hours) : null;
          // i.weeks=(i.weeks!=null &&i.weeks!=undefined)?parseInt(i.weeks):null;
          i.total = (i.total != null && i.total != undefined) ? parseFloat(i.total) : null;

        })
      }

    }
    if (budget.treatmentAndTraining.serviceAssistance.length > 0) {
      if (budget.treatmentAndTraining.serviceAssistance.length == 1 && budget.treatmentAndTraining.serviceAssistance[0].payorName == null && budget.treatmentAndTraining.serviceAssistance[0].groupPayorServiceId == null) {
        budget.treatmentAndTraining.serviceAssistance = [];
      }
      else {
        budget.treatmentAndTraining.serviceAssistance.forEach(i => {
          i.rate = (i.rate != null && i.rate != undefined) ? parseFloat(i.rate) : null;
          i.hours = (i.hours != null && i.hours != undefined) ? parseInt(i.hours) : null;
          // i.weeks=(i.weeks!=null &&i.weeks!=undefined)?parseInt(i.weeks):null;
          i.total = (i.total != null && i.total != undefined) ? parseFloat(i.total) : null;

        })
      }

    }
    if (budget.environmentalModificationAndProvisions.serviceAssistance.length > 0) {
      if (budget.environmentalModificationAndProvisions.serviceAssistance.length == 1 && budget.environmentalModificationAndProvisions.serviceAssistance[0].payorName == null && budget.environmentalModificationAndProvisions.serviceAssistance[0].groupPayorServiceId == null) {
        budget.environmentalModificationAndProvisions.serviceAssistance = [];
      }
      else {
        budget.environmentalModificationAndProvisions.serviceAssistance.forEach(i => {
          i.rate = (i.rate != null && i.rate != undefined) ? parseFloat(i.rate) : null;
          i.hours = (i.hours != null && i.hours != undefined) ? parseInt(i.hours) : null;
          // i.weeks=(i.weeks!=null &&i.weeks!=undefined)?parseInt(i.weeks):null;
          i.total = (i.total != null && i.total != undefined) ? parseFloat(i.total) : null;

        })
      }

    }

    if (budget.selfDirectionSupportActivities.serviceAssistance.length > 0) {
      if (budget.selfDirectionSupportActivities.serviceAssistance.length == 1 && budget.selfDirectionSupportActivities.serviceAssistance[0].payorName == null && budget.selfDirectionSupportActivities.serviceAssistance[0].groupPayorServiceId == null) {
        budget.selfDirectionSupportActivities.serviceAssistance = [];
      }
      else {
        budget.selfDirectionSupportActivities.serviceAssistance.forEach(i => {
          i.rate = (i.rate != null && i.rate != undefined) ? parseFloat(i.rate) : null;
          i.hours = (i.hours != null && i.hours != undefined) ? parseInt(i.hours) : null;
          // i.weeks=(i.weeks!=null &&i.weeks!=undefined)?parseInt(i.weeks):null;
          i.total = (i.total != null && i.total != undefined) ? parseFloat(i.total) : null;

        })
      }


    }

    budget.selfDirectionSupportActivities.annualBudgetBO.annualBudget = (budget.selfDirectionSupportActivities.annualBudgetBO.annualBudget != null && budget.selfDirectionSupportActivities.annualBudgetBO.annualBudget != undefined) ? parseFloat(budget.selfDirectionSupportActivities.annualBudgetBO.annualBudget) : null;



    // budget.personRecevingServices.medicareOrInsuranceNumber=parseFloat(budget.personRecevingServices.medicareOrInsuranceNumber);
    budget.selfDirectionSupportActivities.annualBudgetBO.nursingServices.totalPersonAssistance = (budget.selfDirectionSupportActivities.annualBudgetBO.nursingServices.totalPersonAssistance != null && budget.selfDirectionSupportActivities.annualBudgetBO.nursingServices.totalPersonAssistance != undefined) ? parseFloat(budget.selfDirectionSupportActivities.annualBudgetBO.nursingServices.totalPersonAssistance) : null;
    budget.selfDirectionSupportActivities.annualBudgetBO.nursingServices.totalTreatmentandTraining = (budget.selfDirectionSupportActivities.annualBudgetBO.nursingServices.totalTreatmentandTraining != null && budget.selfDirectionSupportActivities.annualBudgetBO.nursingServices.totalTreatmentandTraining != undefined) ? parseFloat(budget.selfDirectionSupportActivities.annualBudgetBO.nursingServices.totalTreatmentandTraining) : null;
    budget.selfDirectionSupportActivities.annualBudgetBO.nursingServices.totalEnvironmentModification = (budget.selfDirectionSupportActivities.annualBudgetBO.nursingServices.totalEnvironmentModification != null && budget.selfDirectionSupportActivities.annualBudgetBO.nursingServices.totalEnvironmentModification != undefined) ? parseFloat(budget.selfDirectionSupportActivities.annualBudgetBO.nursingServices.totalEnvironmentModification) : null;
    budget.selfDirectionSupportActivities.annualBudgetBO.nursingServices.totalSelfDirectionSupportActivities = (budget.selfDirectionSupportActivities.annualBudgetBO.nursingServices.totalSelfDirectionSupportActivities != null && budget.selfDirectionSupportActivities.annualBudgetBO.nursingServices.totalSelfDirectionSupportActivities != undefined) ? parseFloat(budget.selfDirectionSupportActivities.annualBudgetBO.nursingServices.totalSelfDirectionSupportActivities) : null;
    budget.selfDirectionSupportActivities.annualBudgetBO.nursingServices.totalMAHomeCareService = (budget.selfDirectionSupportActivities.annualBudgetBO.nursingServices.totalMAHomeCareService != null && budget.selfDirectionSupportActivities.annualBudgetBO.nursingServices.totalMAHomeCareService != undefined) ? parseFloat(budget.selfDirectionSupportActivities.annualBudgetBO.nursingServices.totalMAHomeCareService) : null;
    budget.selfDirectionSupportActivities.annualBudgetBO.nursingServices.grandTotal = (budget.selfDirectionSupportActivities.annualBudgetBO.nursingServices.grandTotal != null && budget.selfDirectionSupportActivities.annualBudgetBO.nursingServices.grandTotal != undefined) ? parseFloat(budget.selfDirectionSupportActivities.annualBudgetBO.nursingServices.grandTotal) : null;
    budget.selfDirectionSupportActivities.annualBudgetBO.nursingServices.usedBudgetAmount = (budget.selfDirectionSupportActivities.annualBudgetBO.nursingServices.usedBudgetAmount != null && budget.selfDirectionSupportActivities.annualBudgetBO.nursingServices.usedBudgetAmount != undefined) ? parseFloat(budget.selfDirectionSupportActivities.annualBudgetBO.nursingServices.usedBudgetAmount) : null;

    budget.personalAssistance.grandtotal = (budget.personalAssistance.grandtotal != null && budget.personalAssistance.grandtotal != undefined) ? parseFloat(budget.personalAssistance.grandtotal) : null;
    budget.treatmentAndTraining.grandtotal = (budget.treatmentAndTraining.grandtotal != null && budget.treatmentAndTraining.grandtotal != undefined) ? parseFloat(budget.treatmentAndTraining.grandtotal) : null;
    budget.environmentalModificationAndProvisions.grandtotal = (budget.environmentalModificationAndProvisions.grandtotal != null && budget.environmentalModificationAndProvisions.grandtotal != undefined) ? parseFloat(budget.environmentalModificationAndProvisions.grandtotal) : null;
    budget.selfDirectionSupportActivities.grandtotal = (budget.selfDirectionSupportActivities.grandtotal != null && budget.selfDirectionSupportActivities.grandtotal != undefined) ? parseFloat(budget.selfDirectionSupportActivities.grandtotal) : null;




    budget.budgetStartDate = (budget.budgetStartDate != null && budget.budgetStartDate != '' && budget.budgetStartDate != undefined) ? (new Date(new Date(budget.budgetStartDate).toLocaleDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "") : null;
    budget.budgetEndDate = (budget.budgetEndDate != null && budget.budgetEndDate != '' && budget.budgetEndDate != undefined) ? (new Date(new Date(budget.budgetEndDate).toDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "") : null;
    budget.budgetdate = (budget.budgetdate != null && budget.budgetdate != '' && budget.budgetdate != undefined) ? (new Date(new Date(budget.budgetdate).toDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "") : null;


    budget.personRecevingServices.dob = (budget.personRecevingServices.dob != null && budget.personRecevingServices.dob != undefined && budget.personRecevingServices.dob != '') ? (new Date(new Date(budget.personRecevingServices.dob).toDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "") : null;
    budget.selfDirectionSupportActivities.annualBudgetBO.budgetCoverPlanStart = (budget.selfDirectionSupportActivities.annualBudgetBO.budgetCoverPlanStart != null && budget.selfDirectionSupportActivities.annualBudgetBO.budgetCoverPlanStart != undefined && budget.selfDirectionSupportActivities.annualBudgetBO.budgetCoverPlanStart != '') ? (new Date(new Date(budget.selfDirectionSupportActivities.annualBudgetBO.budgetCoverPlanStart).toDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "") : null;
    budget.selfDirectionSupportActivities.annualBudgetBO.budgetCoverPlanEnd = (budget.selfDirectionSupportActivities.annualBudgetBO.monitor.healthandSafetyPlanBO.whatWill_IDoInCaseDate != '' && budget.selfDirectionSupportActivities.annualBudgetBO.budgetCoverPlanEnd != null && budget.selfDirectionSupportActivities.annualBudgetBO.budgetCoverPlanEnd != undefined) ? (new Date(new Date(budget.selfDirectionSupportActivities.annualBudgetBO.budgetCoverPlanEnd).toDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "") : null;
    budget.selfDirectionSupportActivities.annualBudgetBO.monitor.healthandSafetyPlanBO.whatWill_IDoInCaseDate = (budget.selfDirectionSupportActivities.annualBudgetBO.monitor.healthandSafetyPlanBO.whatWill_IDoInCaseDate != null && budget.selfDirectionSupportActivities.annualBudgetBO.monitor.healthandSafetyPlanBO.whatWill_IDoInCaseDate != undefined && budget.selfDirectionSupportActivities.annualBudgetBO.monitor.healthandSafetyPlanBO.whatWill_IDoInCaseDate != '') ? (new Date(new Date(budget.selfDirectionSupportActivities.annualBudgetBO.monitor.healthandSafetyPlanBO.whatWill_IDoInCaseDate).toDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "") : null;
    budget.selfDirectionSupportActivities.annualBudgetBO.monitor.healthandSafetyPlanBO.receipientSignDate = (budget.selfDirectionSupportActivities.annualBudgetBO.monitor.healthandSafetyPlanBO.receipientSignDate != null && budget.selfDirectionSupportActivities.annualBudgetBO.monitor.healthandSafetyPlanBO.receipientSignDate != undefined && budget.selfDirectionSupportActivities.annualBudgetBO.monitor.healthandSafetyPlanBO.receipientSignDate != '') ? (new Date(new Date(budget.selfDirectionSupportActivities.annualBudgetBO.monitor.healthandSafetyPlanBO.receipientSignDate).toDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "") : null;
    budget.selfDirectionSupportActivities.annualBudgetBO.monitor.healthandSafetyPlanBO.parent_Legal_Representative_Managing_Party_SignDate = (budget.selfDirectionSupportActivities.annualBudgetBO.monitor.healthandSafetyPlanBO.parent_Legal_Representative_Managing_Party_SignDate != null && budget.selfDirectionSupportActivities.annualBudgetBO.monitor.healthandSafetyPlanBO.parent_Legal_Representative_Managing_Party_SignDate != '' && budget.selfDirectionSupportActivities.annualBudgetBO.monitor.healthandSafetyPlanBO.parent_Legal_Representative_Managing_Party_SignDate != undefined) ? (new Date(new Date(budget.selfDirectionSupportActivities.annualBudgetBO.monitor.healthandSafetyPlanBO.parent_Legal_Representative_Managing_Party_SignDate).toDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "") : null;
    budget.selfDirectionSupportActivities.annualBudgetBO.monitor.healthandSafetyPlanBO.lead_Agency_Representative_Care_Manager_SignDate = (budget.selfDirectionSupportActivities.annualBudgetBO.monitor.healthandSafetyPlanBO.lead_Agency_Representative_Care_Manager_SignDate != '' && budget.selfDirectionSupportActivities.annualBudgetBO.monitor.healthandSafetyPlanBO.lead_Agency_Representative_Care_Manager_SignDate != null && budget.selfDirectionSupportActivities.annualBudgetBO.monitor.healthandSafetyPlanBO.lead_Agency_Representative_Care_Manager_SignDate != undefined) ? (new Date(new Date(budget.selfDirectionSupportActivities.annualBudgetBO.monitor.healthandSafetyPlanBO.lead_Agency_Representative_Care_Manager_SignDate).toDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "") : null;
    budget.selfDirectionSupportActivities.annualBudgetBO.monitor.healthandSafetyPlanBO.date = (budget.selfDirectionSupportActivities.annualBudgetBO.monitor.healthandSafetyPlanBO.date != '' && budget.selfDirectionSupportActivities.annualBudgetBO.monitor.healthandSafetyPlanBO.date != null && budget.selfDirectionSupportActivities.annualBudgetBO.monitor.healthandSafetyPlanBO.date != undefined) ? (new Date(new Date(budget.selfDirectionSupportActivities.annualBudgetBO.monitor.healthandSafetyPlanBO.date).toDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "") : null;
    //  budget.id= this.budgetPlan.id;

    this.budgetService.savebudget(budget).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (data.errorList.length == 0) {
        if (this.budgetPlan.id == "00000000-0000-0000-0000-000000000000") {
          this.toastrService.success('Budget Imported Successfully');
        }
        else {
          this.toastrService.success('Budget Updated Successfully');
        }
      }
      else {
        this.budgetErrorList = [];
        this.budgetErrorList = data.errorList;
        this.toastrService.error(this.budgetErrorList.toString(), 'Error');
        //this.saveClientInProgress = false;
        setTimeout(() => {
          this.toastrService.clear()
        }, 10000);

      }



      this.closeFun();
    }, (err: HttpErrorResponse) => {

      this.toastrService.error(err.error);
      this.budgetImportBO.budgetStartDate = this.datepipe.transform(this.budgetImportBO.budgetStartDate, "MM/dd/yyyy")
      this.budgetImportBO.budgetEndDate = this.datepipe.transform(this.budgetImportBO.budgetEndDate, "MM/dd/yyyy")
      this.budgetImportBO.budgetdate = this.datepipe.transform(this.budgetImportBO.budgetdate, "MM/dd/yyyy")
      // this.budgetImportBO.personRecevingServices.dob=this.datepipe.transform(this.budgetImportBO.personRecevingServices.dob,"MM/dd/yyyy")

    })

  }
  close() {
    document.getElementById("openandcloserecipientsignmodal").click();

  }
  close1() {
    document.getElementById("openandcloseparentsignmodal").click();
  }
  close2() {
    document.getElementById("openandcloseleadAgencysignmodal").click();
  }


  getPayorList() {
    if (this.global.LoginEntityType == 'ADMIN') {
      this.budgetService.getPayorDrop().pipe(takeUntil(this.onDestroy$)).subscribe((data: any = []) => {

        this.payorList = data;
      },
        err => {

        })
    }
    else {
   

        let list1:any
        this.budgetService.getPayorDropDown(list1).pipe(takeUntil(this.onDestroy$)).subscribe((data: any = []) => {
  
          this.payorList = data;
        },
          err => {
  
          })
    }

  }
  payorList: [{ Key: string, Value: string }];
  grouppayorServiceArray: any;
  grouppayorServiceArray1: any;
  getErr_count: string = '';

  serviceinbox: any = [];
  serviceObjList: any = {};
  // updateAuthList: any = new ClientAuthorizationBO();
  serviceCodeUpdate(index, value, arrayName) {
    if (value != "" && value != undefined && value != null) {
      let params = new URLSearchParams();
      params.append("Id", value);

      this.budgetService.getServiceDescription(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

        //   if(arrayName == 'personalAssistance')
        //   {
        //     this.budgetImportBO.personalAssistance.serviceAssistances[index].serviceDescription = data.serviceDescription;
        //   }
        //  else if(arrayName == 'personalAssist')
        //   {
        //     this.budgetImportBO.treatmentAndTraining.serviceAssistance[index].serviceDescription = data.serviceDescription;
        //   }
        //  else if(arrayName == 'personal')
        //   {
        //     this.budgetImportBO.environmentalModificationAndProvisions.serviceAssistance[index].serviceDescription = data.serviceDescription;
        //   }
        //  else if(arrayName == 'person')
        //   {
        //     this.budgetImportBO.selfDirectionSupportActivities.serviceAssistance[index].serviceDescription = data.serviceDescription;
        //   }

      });
    }
    else {
      //   if(arrayName == 'personalAssistance')
      //   {
      //     this.budgetImportBO.personalAssistance.serviceAssistances[index].serviceDescription = null;
      //   }
      //  else if(arrayName == 'personalAssist')
      //   {
      //     this.budgetImportBO.treatmentAndTraining.serviceAssistance[index].serviceDescription = null;

      //   }
      //  else if(arrayName == 'personal')
      //   {
      //     this.budgetImportBO.environmentalModificationAndProvisions.serviceAssistance[index].serviceDescription = null;
      //   }
      //   else if(arrayName == 'person')
      //   {
      //     this.budgetImportBO.selfDirectionSupportActivities.serviceAssistance[index].serviceDescription = null;
      //   }

    }

  }
  ///////////////////////////total hours per day /////////////////////////////////////////

  calculatetotal(start, end, unit, i, billingvalue, rate) {


    if (start != null && end != null && unit != null && start != '' && end != '') {
      let diffDays = (Number(Math.abs(new Date(end).getTime() - new Date(start).getTime()) / (1000 * 60 * 60 * 24))) + 1;
      let units = unit / diffDays;
      let val = (units / billingvalue).toFixed(4).toString();
      let val2 = val.split('.');



      if (val2.length == 1) {
        if (billingvalue == undefined || billingvalue == 0 || billingvalue == null) {
          // this.budgetImportBO.environmentalModificationAndProvisions.serviceAssistance[i].unitperday=''
          // this.budgetImportBO.environmentalModificationAndProvisions.serviceAssistance[i].weeks=''

        }
        else {
          // this.budgetImportBO.environmentalModificationAndProvisions.serviceAssistance[i].unitperday = val2[0] + " hr " + "0 Min";
          // this.budgetImportBO.environmentalModificationAndProvisions.serviceAssistance[i].weeks=parseInt(val2[0])*7 + " hr " + "0 Min"
        }


      }

      else {
        if (billingvalue == undefined || billingvalue == 0 || billingvalue == null) {
          // this.budgetImportBO.environmentalModificationAndProvisions.serviceAssistance[i].unitperday=''
         
          // this.budgetImportBO.environmentalModificationAndProvisions.serviceAssistance[i].weeks=''

        }
        else {
          let vals2 = 0 + "." + val2[val2.length - 1];
          // this.budgetImportBO.environmentalModificationAndProvisions.serviceAssistance[i].unitperday = val2[0] + " hr " + (parseFloat(vals2) * 60).toString().split('.')[0] + "Min";
          // this.budgetImportBO.environmentalModificationAndProvisions.serviceAssistance[i].weeks=parseInt(val2[0])*7 + " hr " + (parseFloat(vals2) * 60).toString().split('.')[0] + "Min";


        }


      }
   
      if (rate != null && rate != undefined && rate != "" && unit != null && unit != undefined && unit != "") {
        let sum = 0;
        if (billingvalue == undefined || billingvalue == 0 || billingvalue == null) {
          // this.budgetImportBO.environmentalModificationAndProvisions.serviceAssistance[i].total=0
        }
        else {
          let total = rate * unit / billingvalue;
          // this.budgetImportBO.environmentalModificationAndProvisions.serviceAssistance[i].total=Number(total);  

        }
       



      }



    }
  }

 

  grouppayor_serviceDescription: any = [];
  billingvalue: number;
  saveAuthErr1: string = "";
  saveAuthErr2: string = "";
  saveAuthErr3: string = "";
  saveAuthErr4: string = "";
  getbillingValue1(id, Contact) {
    if (this.global.LoginUserType.toUpperCase() == 'ONBOARD') {
      if (id != undefined) {
        let params = new URLSearchParams();
        params.append("grouppayor", id.groupPayorServiceId);

        this.budgetService.getbillingvalue(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
          id.billingvalue = data;
          if (id.billingvalue == 0) {
            id.billingvalue = 0;
            this.saveAuthErr1 = "There is no Billing Unit "

          }
          else {
            this.saveAuthErr1 = ''
          }
          // else {
          //   if (this.updateAuthList.personalAssistance.serviceAssistances.hours != null && this.updateAuthList.personalAssistance.serviceAssistances.hours != undefined && this.updateAuthList.personalAssistance.serviceAssistances.hours!= '' && this.updateAuthList.personalAssistance.serviceAssistances.hours != "") {
          //     // this.calculatetotalhour(this.updateAuthList.budgetStartDate, this.updateAuthList.budgetEndDate,this.updateAuthList.personalAssistance.serviceAssistances.hours,id,this.billingvalue)
          //   }

          // }
        }, (err: HttpErrorResponse) => {
          if (err.error.errors) {
            this.getErr_count = JSON.stringify(err.error.errors);
          }
          else {
            this.getErr_count = JSON.stringify(err.error);

          } if (this.getErr_count != "") {
            setTimeout(() => {
              this.getErr_count = "";
            }, 8000)
          }

        })

      }
      else { this.billingvalue = 0 }
    }
    else {
      if (id != undefined) {
        let params = new URLSearchParams();
        params.append("grouppayor", id.groupPayorServiceId);

        this.budgetService.getbilling(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
          id.billingvalue = data;
          if (id.billingvalue == 0) {
            id.billingvalue = 0;

            this.saveAuthErr1 = "There is no Billing Unit "

          }
          else {
            this.saveAuthErr1 = ''
          }
          // else {
          //   if (this.updateAuthList.personalAssistance.serviceAssistances.hours != null && this.updateAuthList.personalAssistance.serviceAssistances.hours != undefined && this.updateAuthList.personalAssistance.serviceAssistances.hours != '' && this.updateAuthList.personalAssistance.serviceAssistances.hours != "") {
          //     // this.calculatetotalhour(this.updateAuthList.budgetStartDate, this.updateAuthList.budgetEndDate,this.updateAuthList.personalAssistance.serviceAssistances.hours,id, this.billingvalue)
          //   }

          // }
        }, (err: HttpErrorResponse) => {
          if (err.error.errors) {
            this.getErr_count = JSON.stringify(err.error.errors);
          }
          else {
            this.getErr_count = JSON.stringify(err.error);

          } if (this.getErr_count != "") {
            setTimeout(() => {
              this.getErr_count = "";
            }, 8000)
          }

        })

      }
      else { this.billingvalue = 0 }
    }

  }
  getbillingValue2(id) {
    if (this.global.LoginUserType.toUpperCase() == 'ONBOARD') {
      if (id != undefined) {
        let params = new URLSearchParams();
        params.append("grouppayor", id.groupPayorServiceId);

        this.budgetService.getbillingvalue(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
          id.billingvalue = data;
          if (id.billingvalue == 0) {
            id.billingvalue = 0;
            this.updateAuthList.treatmentAndTraining.serviceAssistance.billingvalue = id.billingvalue
            this.saveAuthErr2 = "There is no Billing Unit "

          }
          else {
            this.saveAuthErr2 = ''
          }
          // else {
          //   if (this.updateAuthList.personalAssistance.serviceAssistances.hours != null && this.updateAuthList.personalAssistance.serviceAssistances.hours != undefined && this.updateAuthList.personalAssistance.serviceAssistances.hours!= '' && this.updateAuthList.personalAssistance.serviceAssistances.hours != "") {
          //     // this.calculatetotalhour(this.updateAuthList.budgetStartDate, this.updateAuthList.budgetEndDate,this.updateAuthList.personalAssistance.serviceAssistances.hours,id,this.billingvalue)
          //   }

          // }
        }, (err: HttpErrorResponse) => {
          if (err.error.errors) {
            this.getErr_count = JSON.stringify(err.error.errors);
          }
          else {
            this.getErr_count = JSON.stringify(err.error);

          } if (this.getErr_count != "") {
            setTimeout(() => {
              this.getErr_count = "";
            }, 8000)
          }

        })

      }
      else { this.billingvalue = 0 }
    }
    else {
      if (id != undefined) {
        let params = new URLSearchParams();
        params.append("grouppayor", id.groupPayorServiceId);

        this.budgetService.getbilling(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
          id.billingvalue = data;
          if (id.billingvalue == 0) {
            id.billingvalue = 0;
            this.updateAuthList.treatmentAndTraining.serviceAssistance.billingvalue = id.billingvalue

            this.saveAuthErr2 = "There is no Billing Unit "

          }
          else {
            this.saveAuthErr2 = ''
          }
          // else {
          //   if (this.updateAuthList.personalAssistance.serviceAssistances.hours != null && this.updateAuthList.personalAssistance.serviceAssistances.hours != undefined && this.updateAuthList.personalAssistance.serviceAssistances.hours != '' && this.updateAuthList.personalAssistance.serviceAssistances.hours != "") {
          //     // this.calculatetotalhour(this.updateAuthList.budgetStartDate, this.updateAuthList.budgetEndDate,this.updateAuthList.personalAssistance.serviceAssistances.hours,id, this.billingvalue)
          //   }

          // }
        }, (err: HttpErrorResponse) => {
          if (err.error.errors) {
            this.getErr_count = JSON.stringify(err.error.errors);
          }
          else {
            this.getErr_count = JSON.stringify(err.error);

          } if (this.getErr_count != "") {
            setTimeout(() => {
              this.getErr_count = "";
            }, 8000)
          }

        })

      }
      else { this.billingvalue = 0 }
    }

  }
  getbillingValue3(id) {

    if (this.global.LoginUserType.toUpperCase() == 'ONBOARD') {
      if (id != undefined) {
        let params = new URLSearchParams();
        params.append("grouppayor", id.groupPayorServiceId);

        this.budgetService.getbillingvalue(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
          id.billingvalue = data;
          if (id.billingvalue == 0) {
            id.billingvalue = 0;
            this.updateAuthList.environmentalModificationAndProvisions.serviceAssistance.billingvalue = id.billingvalue
            this.saveAuthErr3 = "There is no Billing Unit "

          }
          else {
            this.saveAuthErr3 = ''
          }
          // else {
          //   if (this.updateAuthList.personalAssistance.serviceAssistances.hours != null && this.updateAuthList.personalAssistance.serviceAssistances.hours != undefined && this.updateAuthList.personalAssistance.serviceAssistances.hours!= '' && this.updateAuthList.personalAssistance.serviceAssistances.hours != "") {
          //     // this.calculatetotalhour(this.updateAuthList.budgetStartDate, this.updateAuthList.budgetEndDate,this.updateAuthList.personalAssistance.serviceAssistances.hours,id,this.billingvalue)
          //   }

          // }
        }, (err: HttpErrorResponse) => {
          if (err.error.errors) {
            this.getErr_count = JSON.stringify(err.error.errors);
          }
          else {
            this.getErr_count = JSON.stringify(err.error);

          } if (this.getErr_count != "") {
            setTimeout(() => {
              this.getErr_count = "";
            }, 8000)
          }

        })

      }
      else { this.billingvalue = 0 }
    }
    else {
      if (id != undefined) {
        let params = new URLSearchParams();
        params.append("grouppayor", id.groupPayorServiceId);

        this.budgetService.getbilling(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
          id.billingvalue = data;
          if (id.billingvalue == 0) {
            id.billingvalue = 0;
            this.updateAuthList.environmentalModificationAndProvisions.serviceAssistance.billingvalue = id.billingvalue

            this.saveAuthErr3 = "There is no Billing Unit "

          }
          else {
            this.saveAuthErr3 = ''
          }
          // else {
          //   if (this.updateAuthList.personalAssistance.serviceAssistances.hours != null && this.updateAuthList.personalAssistance.serviceAssistances.hours != undefined && this.updateAuthList.personalAssistance.serviceAssistances.hours != '' && this.updateAuthList.personalAssistance.serviceAssistances.hours != "") {
          //     // this.calculatetotalhour(this.updateAuthList.startDate, this.updateAuthList.budgetEndDate,this.updateAuthList.personalAssistance.serviceAssistances.hours,id, this.billingvalue)
          //   }

          // }
        }, (err: HttpErrorResponse) => {
          if (err.error.errors) {
            this.getErr_count = JSON.stringify(err.error.errors);
          }
          else {
            this.getErr_count = JSON.stringify(err.error);

          } if (this.getErr_count != "") {
            setTimeout(() => {
              this.getErr_count = "";
            }, 8000)
          }

        })

      }
      else { this.billingvalue = 0 }
    }

  }
  getbillingValue4(id) {
    if (this.global.LoginUserType.toUpperCase() == 'ONBOARD') {
      if (id != undefined) {
        let params = new URLSearchParams();
        params.append("grouppayor", id.groupPayorServiceId);

        this.budgetService.getbillingvalue(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
          id.billingvalue = data;
          if (id.billingvalue == 0) {
            id.billingvalue = 0;
            this.updateAuthList.selfDirectionSupportActivities.serviceAssistance.billingvalue = id.billingvalue
            this.saveAuthErr4 = "There is no Billing Unit "

          }
          else {
            this.saveAuthErr4 = ''
          }
          // else {
          //   if (this.updateAuthList.personalAssistance.serviceAssistances.hours != null && this.updateAuthList.personalAssistance.serviceAssistances.hours != undefined && this.updateAuthList.personalAssistance.serviceAssistances.hours!= '' && this.updateAuthList.personalAssistance.serviceAssistances.hours != "") {
          //     // this.calculatetotalhour(this.updateAuthList.startDate, this.updateAuthList.budgetEndDate,this.updateAuthList.personalAssistance.serviceAssistances.hours,id,this.billingvalue)
          //   }

          // }
        }, (err: HttpErrorResponse) => {
          if (err.error.errors) {
            this.getErr_count = JSON.stringify(err.error.errors);
          }
          else {
            this.getErr_count = JSON.stringify(err.error);

          } if (this.getErr_count != "") {
            setTimeout(() => {
              this.getErr_count = "";
            }, 8000)
          }

        })

      }
      else { this.billingvalue = 0 }
    }
    else {
      if (id != undefined) {
        let params = new URLSearchParams();
        params.append("grouppayor", id.groupPayorServiceId);

        this.budgetService.getbilling(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
          id.billingvalue = data;
          if (id.billingvalue == 0) {
            id.billingvalue = 0;
            this.updateAuthList.selfDirectionSupportActivities.serviceAssistance.billingvalue = id.billingvalue

            this.saveAuthErr4 = "There is no Billing Unit "

          }
          else {
            this.saveAuthErr4 = ''
          }
          // else {
          //   if (this.updateAuthList.personalAssistance.serviceAssistances.hours != null && this.updateAuthList.personalAssistance.serviceAssistances.hours != undefined && this.updateAuthList.personalAssistance.serviceAssistances.hours != '' && this.updateAuthList.personalAssistance.serviceAssistances.hours != "") {
          //     // this.calculatetotalhour(this.updateAuthList.startDate, this.updateAuthList.budgetEndDate,this.updateAuthList.personalAssistance.serviceAssistances.hours,id, this.billingvalue)
          //   }

          // }
        }, (err: HttpErrorResponse) => {
          if (err.error.errors) {
            this.getErr_count = JSON.stringify(err.error.errors);
          }
          else {
            this.getErr_count = JSON.stringify(err.error);

          } if (this.getErr_count != "") {
            setTimeout(() => {
              this.getErr_count = "";
            }, 8000)
          }

        })

      }
      else { this.billingvalue = 0 }
    }

  }
  ServiceDropdown: any;

  //================================get group payor service=======================//
  grouppayorService(id, dta: boolean) {
    if (this.global.LoginUserType.toUpperCase() == 'ONBOARD') {
      if (id.groupPayorId != undefined && id.groupPayorId != null) {
        let params = new URLSearchParams();
        this.ngxservice.startLoader('authloader');
        params.append("payorId", id.groupPayorId.toString());
        this.budgetService.getgrouppayorservice(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
          this.grouppayorServiceArray = data;


          this.ngxservice.stopLoader('authloader')
          this.grouppayorServiceArray.forEach(element => {
            element.Value = element.masterservice.toString();
            element.Key = element.id.toString();
          })
          this.grouppayorServiceArray1 = data;
          this.ngxservice.stopLoader('authloader')
          this.grouppayorServiceArray1.forEach(element => {
            element.Value = element.masterservice.toString();
            element.Key = element.id.toString();
          })
          id.grouppayorServiceArray = this.grouppayorServiceArray;

          if (dta == true) {
            id.groupPayorServiceId = null;
            id.serviceDescription = null;

          }


        }, (err: HttpErrorResponse) => {
          this.ngxservice.stopLoader('authloader')
          id.grouppayorServiceArray = null; id.groupPayorServiceId = null; id.serviceDescription = null
          if (err.error.errors) {
            this.getErr_count = JSON.stringify(err.error.errors);
          }
          else {
            this.getErr_count = JSON.stringify(err.error);

          } if (this.getErr_count != "") {
            setTimeout(() => {
              this.getErr_count = "";
            }, 8000)
          }

        })

      }
      else { id.grouppayorServiceArray = null; id.groupPayorServiceId = null; id.serviceDescription = null }


    }
    else {
      if (id.groupPayorId != undefined && id.groupPayorId != null) {
        let params = new URLSearchParams();
        this.ngxservice.startLoader('authloader');
        params.append("payorId", id.groupPayorId.toString());
        this.budgetService.getgrouppayor(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
          this.grouppayorServiceArray = data;


          this.ngxservice.stopLoader('authloader')
          this.grouppayorServiceArray.forEach(element => {
            element.Value = element.masterservice.toString();
            element.Key = element.id.toString();
          })
          this.grouppayorServiceArray1 = data;
          this.ngxservice.stopLoader('authloader')
          this.grouppayorServiceArray1.forEach(element => {
            element.Value = element.masterservice.toString();
            element.Key = element.id.toString();
          })
          id.grouppayorServiceArray = this.grouppayorServiceArray;

          if (dta == true) {
            id.groupPayorServiceId = null;
            id.serviceDescription = null;

          }


        }, (err: HttpErrorResponse) => {
          this.ngxservice.stopLoader('authloader')
          id.grouppayorServiceArray = null; id.groupPayorServiceId = null; id.serviceDescription = null
          if (err.error.errors) {
            this.getErr_count = JSON.stringify(err.error.errors);
          }
          else {
            this.getErr_count = JSON.stringify(err.error);

          } if (this.getErr_count != "") {
            setTimeout(() => {
              this.getErr_count = "";
            }, 8000)
          }

        })

      }
      else { id.grouppayorServiceArray = null; id.groupPayorServiceId = null; id.serviceDescription = null }

    }


  }
  public saveAuthErr: string = '';
  checkdate() {
    if (new Date(this.budgetImportBO.budgetStartDate).getTime() > new Date(this.budgetImportBO.budgetEndDate).getTime()) {

      this.saveAuthErr = "End date must be larger than start date";
      this.toastrService.error(this.saveAuthErr);

    }

    else {
      this.saveAuthErr = '';
      this.SAveBudget();

    }


  }

  
  OnboardList: any
  GetClientEvaluation: GetClientEvaluation = new GetClientEvaluation();
  public sd: any;
  public ed: string;
  public rate1: any;
  clientDetails: ClientDetailsShow = new ClientDetailsShow()
  bind_ClientValues(ClientId) {
    let params = new URLSearchParams();
    params.append("ClientId", ClientId);

    if (this.global.LoginUserType.toUpperCase() == 'ONBOARD') {
      this.budgetService.GetAllClientDetailsOnboard(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: ClientDetailsShow) => {

        this.clientDetails = data
        if (this.clientDetails.dob != undefined && this.clientDetails.dob != '' && this.clientDetails.dob != null) {
          this.clientDetails.dob = this.datepipe.transform(this.clientDetails.dob, "MM/dd/yyyy")

        }

        // }
      });
    } else {
      this.budgetService.GetAllClientDetails(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: ClientDetailsShow) => {

        this.clientDetails = data
        if (this.clientDetails.dob != undefined && this.clientDetails.dob != '' && this.clientDetails.dob != null) {
          this.clientDetails.dob = this.datepipe.transform(this.clientDetails.dob, "MM/dd/yyyy")

        }

        // }
      });
    }



  }
  value:any
  decimalFilter(event: any) {
    const reg = /^-?\d*(\.\d{0,4})?$/;
    let input = event.target.value + String.fromCharCode(event.charCode);

    if (!reg.test(input)) {
      event.preventDefault();
    }
  }




  parentColumn1: boolean = false;

  Createparent(i) {
    if (this.budgetImportBO.representativeContacts.length > 0) {
      this.parentColumn1 = true;
      // this.budgetImportBO.representativeContacts[i]= new RepresentativeContacts()
      // let list2 = new ClientContactInfoBO()
      //   this.bind_ContactData[i]=list2
      // this.budgetImportBO.representativeContacts[i].isadd=true
    }
    //  this.bind_ContactData[i+1]= new ClientContactInfoBO()

    let list = new RepresentativeContactsBO();
    this.budgetImportBO.representativeContacts.push(list);
    let list1 = new ClientContactInfoBO();
    this.bind_ContactData.push(list1)

  }
  parentColumn2: boolean = false;
  Createparentadditional(i) {
    if (this.budgetImportBO.additionalContactsBo.length > 0) {
      this.parentColumn2 = true;
      // this.budgetImportBO.representativeContacts[i]=new RepresentativeContacts()     
      // this.bind_AdditionalContactData[i]=new ClientContactInfoBO()
    }

    let list = new RepresentativeContactsBO()
    this.budgetImportBO.additionalContactsBo.push(list);
    let list1 = new ClientContactInfoBO();
    this.bind_AdditionalContactData.push(list1)
  }
  removeparent(Contact, BO) {
    if (BO.id == '00000000-0000-0000-0000-000000000000') {
      this.budgetImportBO.representativeContacts.splice(Contact, 1);
      this.bind_ContactData.splice(Contact, 1);
    } else {
      this.budgetImportBO.representativeContacts.splice(Contact, 1);
      this.bind_ContactData.splice(Contact, 1);
      let params = new URLSearchParams();
      params.append("Id", BO.id);
      this.budgetService.deleteRepresentativeContacts(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

        if (data) {
          this.toastrService.success("Deleted Successfully")
        }



      }, (err: HttpErrorResponse) => {


      })
    }



    // if(this.budgetImportBO.parentOrLegalRepresentativeOrManagingParty.length==1){
    //   this.budgetImportBO.parentOrLegalRepresentativeOrManagingParty[0].isadd=false
    // }
  }
  removeparent1(Contact, BO) {
    if (BO.id == '00000000-0000-0000-0000-000000000000') {
      this.budgetImportBO.additionalContactsBo.splice(Contact, 1);
      this.bind_AdditionalContactData.splice(Contact, 1);

    } else {
      this.budgetImportBO.additionalContactsBo.splice(Contact, 1);
      this.bind_AdditionalContactData.splice(Contact, 1);
      let params = new URLSearchParams();
      params.append("Id", BO.id);
      this.budgetService.deleteAdditionalContacts(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

        if (data) {
          this.toastrService.success("Deleted Successfully")
        }



      }, (err: HttpErrorResponse) => {


      })

    }

    // if(this.budgetImportBO.parentOrLegalRepresentativeOrManagingParty.length==1){
    //   this.budgetImportBO.parentOrLegalRepresentativeOrManagingParty[0].isadd=false
    // }
  }


  contactColumn1: boolean = false;






  gettype() {
    // if(this.clientlogin != false && this.employeelogin !=false)
    //  {
    if (this.global.LoginUserType.toUpperCase() == 'ONBOARD') {
      let params = new URLSearchParams();
      params.append("Code", "TYPEOFWAIVER");
      this.budgetService.gettype(params).subscribe((data: any) => {
        this.typelist = data;
        this.typelist.forEach(element => {
          element.Key = element.Key.toString();
        });
      })

    }
    else {
      let params = new URLSearchParams();
      params.append("Code", "TYPEOFWAIVER");
      this.budgetService.getcommon(params).subscribe((data: any) => {
        this.typelist = data;
        this.typelist.forEach(element => {
          element.Key = element.Key.toString();
        });
      })


    }
  }


  typelist: [{ Key: string, Value: string }];


  DemographicPhoneFormat() {
    // this.budgetImportBO.personRecevingServices.phoneNumber = this.general.converPhoneGoogleLib(this.budgetImportBO.personRecevingServices.phoneNumber);
    // this.budgetImportBO.personRecevingServices.phoneNumber = this.general.converPhoneGoogleLib(this.budgetImportBO.personRecevingServices.phoneNumber);
    // this.budgetImportBO.supportPlanner.phoneNumber= this.general.converPhoneGoogleLib(this.budgetImportBO.supportPlanner.phoneNumber);
    // this.budgetImportBO.additionalContact.doctorAdress.phoneNumber = this.general.converPhoneGoogleLib(this.budgetImportBO.additionalContact.doctorAdress.phoneNumber);
    // this.budgetImportBO.additionalContact.hospitalAddress.phoneNumber = this.general.converPhoneGoogleLib(this.budgetImportBO.additionalContact.hospitalAddress.phoneNumber);
    // this.budgetImportBO.additionalContact.schoolAdress.phoneNumber = this.general.converPhoneGoogleLib(this.budgetImportBO.additionalContact.schoolAdress.phoneNumber);

    // this.budgetImportBO.supportPlanner.fax = this.general.converPhoneGoogleLib(this.budgetImportBO.supportPlanner.fax);

    // this.budgetImportBO.additionalContact.doctorAdress.fax = this.general.converPhoneGoogleLib(this.budgetImportBO.additionalContact.doctorAdress.fax);

    // this.budgetImportBO.additionalContact.hospitalAddress.fax = this.general.converPhoneGoogleLib(this.budgetImportBO.additionalContact.hospitalAddress.fax);

    //this.budgetImportBO.additionalContact.schoolAdress.fax = this.general.converPhoneGoogleLib(this.budgetImportBO.additionalContact.schoolAdress.fax);


    // this.budgetImportBO.parentOrLegalRepresentativeOrManagingParty.forEach(element => {
    // element.phoneNumber=this.general.converPhoneGoogleLib(element.phoneNumber)
    // element.cellPhoneNumber=this.general.converPhoneGoogleLib(element.cellPhoneNumber)
    // })
    // this.budgetImportBO.additionalContact.additionalAddress.forEach(element => {
    //   element.phoneNumber = this.general.converPhoneGoogleLib(element.phoneNumber)
    //   element.fax = this.general.converPhoneGoogleLib(element.fax)
    // })
  }

  keyPress(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  NumbersOnly(event: any) {
    const pattern = /^[0-9]*\.?[0-9]*$/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  ///////////////////////case Manager///////////////////

  newcase() {
    this.Case = new caseManagerList()
    this.CaseForm.reset();
  }


  checkpopup(value) {
    if (value == "Name") {
      this.valuechange.Name++;
    }
    if (value == "County") {
      this.valuechange.County++;
    } if (value == "Telephone") {
      this.valuechange.Telephone++;
    } if (value == "Fax") {
      this.valuechange.Fax++;
    }
    if (value == "AlternateFax") {
      this.valuechange.AlternateFax++;
    }
    if (value == "Email") {
      this.valuechange.Email++;
    }
  }
  DemographicPhoneFormat3() {
    this.Case.phone = this.general.converPhoneGoogleLib(this.Case.phone);
  }
  DemographicPhoneFormat1() {
    this.Case.fax = this.general.converPhoneGoogleLib(this.Case.fax);
  }
  DemographicPhoneFormat2() {
    // this.Case.alternate_Fax = this.general.converPhoneGoogleLib(this.Case.alternate_Fax);
    this.contactinfo.phoneNumber = this.general.converPhoneGoogleLib(this.contactinfo.phoneNumber)
    this.contactinfo.alternatePhoneNumber = this.general.converPhoneGoogleLib(this.contactinfo.alternatePhoneNumber)
    this.contactinfo.fax = this.general.converPhoneGoogleLib(this.contactinfo.fax)
  }
  valuechange: any = [];
  openDialog() {
    document.getElementById('opencasemanModal1').click();

  }
  valueschanges() {
    this.valuechange = {
      Name: 0,
      County: 0,
      Telephone: 0,
      Fax: 0,
      AlternateFax: 0,
      Email: 0,
    }
  }
  closecase() {
    document.getElementById('opencasemanModal1').click();
  }
  closecontact() {
    document.getElementById('openContactModal').click();
  }

  SaveOrUpdateCase() {
    var saveList: caseManagerList = JSON.parse(JSON.stringify(this.Case));
    saveList.id=this.Case.id;
    saveList.phone = this.general.reconverPhoneGoogleLib(saveList.phone);
    saveList.fax = this.general.reconverPhoneGoogleLib(saveList.fax);
  
    this.budgetService.saveupdate(saveList).pipe(takeUntil(this.onDestroy$)).subscribe((data: string) => {
      if (data) {
        this.valueschanges();
        //====================== sucess message =============

        this.toastrService.success('Case Manager Saved Successfully', 'Case Manager Saved');
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);

        document.getElementById('opencasemanModal1').click();
        this.getCaseManagerDetails();

      }
    }, (err: any) => {
      if (err) {
        this.toastrService.error(err.error, 'Error'), 8000;
      }
    })
  }

  ////////////////////////////////////

  phonerr1: string[] = []
  phonerr2: string[] = []
  ziperr: string[] = []

  errphone1: boolean[] = []
  errphone2: boolean[] = []
  errZip: boolean[] = []

  bool2: boolean = false;

  bool3: boolean = false;

  bool4: boolean = false;


  phonerr3: string[] = []
  phonerr4: string[] = []
  ziperr1: string[] = []

  errphone3: boolean[] = []
  errphone4: boolean[] = []
  errZip1: boolean[] = []

  bool5: boolean = false;

  bool6: boolean = false;

  bool7: boolean = false;





  validchange1(index, val) {
    if (val.phoneNumber != '' && val.phoneNumber != null && val.phoneNumber != undefined) {
      if (val.phoneNumber.length != 14) {


        this.errphone1[index] = true
        this.phonerr1[index] = 'Enter Valid phone, Enter 10 digit'
        this.bool2 = true

      }
      else {

        this.errphone1[index] = false
        this.phonerr1[index] = ''
        this.bool2 = false
      }
    } else {
      this.errphone1[index] = false
      this.bool2 = false
      this.phonerr1[index] = ''

    }

  }

  validchange2(index, val) {
    if (val.cellPhoneNumber != '' && val.cellPhoneNumber != null && val.cellPhoneNumber != undefined) {
      if (val.cellPhoneNumber.length != 14) {


        this.errphone2[index] = true
        this.phonerr2[index] = 'Enter Valid phone, Enter 10 digit'
        this.bool3 = true

      }
      else {

        this.errphone2[index] = false
        this.phonerr2[index] = ''
        this.bool3 = false
      }
    } else {
      this.errphone2[index] = false
      this.bool3 = false
      this.phonerr2[index] = ''

    }

  }
  validchange3(index, val) {
    if (val.zipcode != '' && val.zipcode != null && val.zipcode != undefined) {
      if (val.zipcode.length <= 4) {


        this.errZip[index] = true
        this.ziperr[index] = 'Enter Valid zip, Enter  5 to 11 digits'
        this.bool4 = true

      }
      else {

        this.errZip[index] = false
        this.ziperr[index] = ''
        this.bool4 = false
      }
    } else {
      this.errZip[index] = false
      this.bool4 = false
      this.ziperr[index] = ''

    }

  }

  validchange4(index, val) {
    if (val.phoneNumber != '' && val.phoneNumber != null && val.phoneNumber != undefined) {
      if (val.phoneNumber.length != 14) {


        this.errphone3[index] = true
        this.phonerr3[index] = 'Enter Valid phone, Enter 10 digit'
        this.bool5 = true

      }
      else {

        this.errphone3[index] = false
        this.phonerr3[index] = ''
        this.bool5 = false
      }
    } else {
      this.errphone3[index] = false
      this.bool5 = false
      this.phonerr3[index] = ''

    }

  }

  validchange5(index, val) {
    if (val.fax != '' && val.fax != null && val.fax != undefined) {
      if (val.fax.length != 14) {


        this.errphone4[index] = true
        this.phonerr4[index] = 'Enter Valid fax, Enter 10 digit'
        this.bool6 = true

      }
      else {

        this.errphone4[index] = false
        this.phonerr4[index] = ''
        this.bool6 = false
      }
    } else {
      this.errphone4[index] = false
      this.bool6 = false
      this.phonerr4[index] = ''

    }

  }
  validchange6(index, val) {
    if (val.zipcode != '' && val.zipcode != null && val.zipcode != undefined) {
      if (val.zipcode.length <= 4) {


        this.errZip1[index] = true
        this.ziperr1[index] = 'Enter Valid zip, Enter  5 to 11 digits'
        this.bool7 = true

      }
      else {

        this.errZip1[index] = false
        this.ziperr1[index] = ''
        this.bool7 = false
      }
    } else {
      this.errZip1[index] = false
      this.bool7 = false
      this.ziperr1[index] = ''

    }

  }
  datebool1: boolean = false;
  dateerr: string;

  validchange7(val) {
    if (val != '' && val != null && val != undefined) {
      if (val != this.datepipe.transform(val, "MM/dd/yyyy")) {
        this.dateerr = 'Please Choose Payer and Service';
        this.datebool1 == true;
      }
      else {
        this.dateerr = "";

        this.datebool1 == false;

      }
    }

  }

  ///////////////////contact ////////////////////

  disabledsavedbutton: boolean = false;
  phoneCarrierList: [{ Key: string, Value: string }];


  newcontact() {
    this.contactinfo = new ClientContactInfoBO();
  }

  SaveOrUpdateContactInfo() {

    this.disabledsavedbutton = true;
    let saveEmployeeContact: ClientContactInfoBO = JSON.parse(JSON.stringify(this.contactinfo));
    saveEmployeeContact.id = this.contactinfo.id;
    saveEmployeeContact.clientId = this.budgetImportBO.clientId;
    saveEmployeeContact.contactTypeLid = this.contactinfo.contactTypeLid
    saveEmployeeContact.relationshipLid = (saveEmployeeContact.relationshipLid != null && saveEmployeeContact.relationshipLid !="" && saveEmployeeContact.relationshipLid !=undefined) ? this.contactinfo.relationshipLid.toString() : null;
    saveEmployeeContact.phoneCarrierLid = ( saveEmployeeContact.phoneCarrierLid != null && saveEmployeeContact.phoneCarrierLid !=undefined && saveEmployeeContact.phoneCarrierLid !="" )? this.contactinfo.phoneCarrierLid.toString() : null;
    if (saveEmployeeContact.alternatePhoneNumber != null) {
      saveEmployeeContact.alternatePhoneNumber = this.general.reconverPhoneGoogleLib(saveEmployeeContact.alternatePhoneNumber);

    }
    if (saveEmployeeContact.fax != null) {
      saveEmployeeContact.fax = this.general.reconverPhoneGoogleLib(saveEmployeeContact.fax);

    }
    if (saveEmployeeContact.phoneNumber != null) {
      saveEmployeeContact.phoneNumber = this.general.reconverPhoneGoogleLib(saveEmployeeContact.phoneNumber);

    }

    this.budgetService.SaveOrUpdateContactInfo(saveEmployeeContact).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

      document.getElementById('openContactModal').click();
      this.toastrService.success('ClientContact has been saved successfully', 'ClientContact Saved');
      setTimeout(() => {
        this.toastrService.clear();
      }, 8000);
      this.ContactInfoForm.reset();
      this.getClientContact(this.budgetImportBO.clientId)


      this.disabledsavedbutton = false;

    }, (err: any) => {
      this.disabledsavedbutton = false;
      if (err) {
        this.toastrService.error(err, 'Error'), 8000;
      }
    })
  }

  getzipcode() {
    let myParams = new URLSearchParams();
    myParams.append("Street", this.contactinfo.street)
    myParams.append("City", this.contactinfo.city)
    myParams.append("State", this.contactinfo.state)
    this.budgetService.getZipcode(myParams).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.contactinfo.zipCode = data.zipcode;
    },
      (err: HttpErrorResponse) => {
        this.toastrService.error(err.error);
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
      }
    );
  }

  ContactRelationshipList: [{ Key: string, Value: string }];

  getPhoneCarrierStatus() {
    let params = new URLSearchParams();
    params.append("ListCode", "PHONECARRIER");
    this.budgetService.gettype(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.phoneCarrierList = data;
    })
  }


  getContactRelationStatus() {
    let params = new URLSearchParams();
    params.append("ListCode", "RELATIONSHIP");
    this.budgetService.gettype(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: [{ Key: string, Value: string }]) => {
      this.ContactRelationshipList = data;
    })

  }
  ContactTypeList: [{ Key: string, Value: string }];
  getContactType() {
    let params = new URLSearchParams();
    params.append("ListCode", "CONTACTTYPE");
    params.append("userId", this.global.userID);
    this.budgetService.gettype(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: [{ Key: string, Value: string }]) => {
      this.ContactTypeList = data;
    })

  }


  /////supportplaner/////
  support: SupportPlannerBO = new SupportPlannerBO();

  PhoneFormat() {
    // this.support.telephone =(this.support.telephone!='' && this.support.telephone!=undefined && this.support.telephone!= null)? this.general.converPhoneGoogleLib(this.support.telephone):null;
    // this.support.fax = (this.support.fax!='' && this.support.fax!=undefined && this.support.fax!= null)?this.general.converPhoneGoogleLib(this.support.fax):null;
    // this.support.alternativeFax = (this.support.alternativeFax!='' && this.support.alternativeFax!=undefined && this.support.alternativeFax!= null)?this.general.converPhoneGoogleLib(this.support.alternativeFax):null;


  }
  get email() {
    return this.form.get('email');
  }

  get zipcode() {
    return this.form.get('zipcode');
  }

  addsupport() {

    let sup = JSON.parse(JSON.stringify(this.support));

    this.supportser.save(sup).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.toastrService.success("saved  Successfully", "support planner saved");
      document.getElementById("opensupportmanModal1").click();
      this.getSupportPlannerDetails();

    },
      err => {
        this.toastrService.error(err.error);

      });

   this.BudgetView.isbasicadvance="";

  }


  closesupport() {
    document.getElementById("opensupportmanModal1").click();
  }

  CaseCreateupdate() {

    this.support = new SupportPlannerBO();
    this.form1.reset()
  }


  ///////
  authclear() {

  }

  CreateContactperson() {


    let succ: boolean = false;
    if (this.budgetImportBO.personalAssistance.length > 0) {
      for (var i = 0; i < this.budgetImportBO.personalAssistance.length; i++) {
        if (this.budgetImportBO.personalAssistance[i].payorName == '' || this.budgetImportBO.personalAssistance[i].payorName == null || this.budgetImportBO.personalAssistance[i].payorName == undefined || this.budgetImportBO.personalAssistance[i].serviceName == null || this.budgetImportBO.personalAssistance[i].serviceName == undefined || this.budgetImportBO.personalAssistance[i].serviceName == '') {
          this.toastrService.error('Please Choose Payer and Service');
          succ = true
        }
        else if (this.budgetImportBO.personalAssistance[i].rate == null || this.budgetImportBO.personalAssistance[i].rate == undefined || this.budgetImportBO.personalAssistance[i].totalhours == null || this.budgetImportBO.personalAssistance[i].totalhours == undefined) {
          this.toastrService.error('Please Enter Rate and Unit');
          succ = true
        }
      }
    }

    if (!succ) {
      if (this.budgetImportBO.personalAssistance.length > 0) {
        let len = this.budgetImportBO.personalAssistance.length
        this.ContactColumn = true;

      }


      let list = new AuthBo();
      this.budgetImportBO.personalAssistance.push(list);

    }



  }
  // private grand=0;
  removeSelectperson(service, i) {
    
    
    if(service.id == null ||service.id == undefined){
    if (this.budgetImportBO.personalAssistance.length >= 1) {
     
      
      if (service.totalAmt == null || service.totalAmt == undefined || service.totalAmt == "") {
      
        this.budgetImportBO.personalAssistance.splice(i, 1);
      }
      else {
             
        this.budgetImportBO.personalAssistance.splice(i, 1);
        this.budgetImportBO.personalAssistanceGrandTotal =Number((this.budgetImportBO.personalAssistanceGrandTotal - service.totalAmt).toFixed(4)) ;

      }
      if(this.budgetImportBO.personalAssistance.length == 0){
        let list = new AuthBo();
        this.budgetImportBO.personalAssistance.push(list);

      }
    

    }
    
    
  }

   else if (service.id != "00000000-0000-0000-0000-000000000000" && service.id != null) {
      let params = new URLSearchParams()
      params.append("Id", service.id)
      this.budgetService.deleteBudgetAuthorization(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

        if (data) {
          this.toastrService.success("Deleted Successfully")
          if (this.budgetImportBO.personalAssistance.length >= 1) {
         
            
            if (service.totalAmt == null || service.totalAmt == undefined || service.totalAmt == "") {
            
              this.budgetImportBO.personalAssistance.splice(i, 1);
            }
            else {
              this.budgetImportBO.personalAssistance.splice(i, 1);
              this.budgetImportBO.personalAssistanceGrandTotal =Number((this.budgetImportBO.personalAssistanceGrandTotal - service.totalAmt) .toFixed(4)) ;
              
            }
            if(this.budgetImportBO.personalAssistance.length == 0){
              let list = new AuthBo();
              this.budgetImportBO.personalAssistance.push(list);

            }
          
      
          }
          
        }

      }, (err: any) => {
        this.toastrService.error("Timesheets are created using this authorization" )
      })
    }

  }


  CreatePersonalAssisGoods() {


    let succ: boolean = false;
    if (this.budgetImportBO.personalAssistanceGoods.length > 0) {
      for (var i = 0; i < this.budgetImportBO.personalAssistanceGoods.length; i++) {
        if (this.budgetImportBO.personalAssistanceGoods[i].payorName == '' || this.budgetImportBO.personalAssistanceGoods[i].payorName == null || this.budgetImportBO.personalAssistanceGoods[i].payorName == undefined || this.budgetImportBO.personalAssistanceGoods[i].serviceName == null || this.budgetImportBO.personalAssistanceGoods[i].serviceName == undefined || this.budgetImportBO.personalAssistanceGoods[i].serviceName == '') {
          this.toastrService.error('Please Choose Payer and Service');
          succ = true
        }
        else if (this.budgetImportBO.personalAssistanceGoods[i].rate == null || this.budgetImportBO.personalAssistanceGoods[i].rate == undefined || this.budgetImportBO.personalAssistanceGoods[i].totalhours == null || this.budgetImportBO.personalAssistanceGoods[i].totalhours == undefined) {
          this.toastrService.error('Please Enter Rate and Unit');
          succ = true
        }
      }
    }

    if (!succ) {
      if (this.budgetImportBO.personalAssistanceGoods.length > 0) {
        let len = this.budgetImportBO.personalAssistanceGoods.length
        this.ContactColumn = true;

      }


      let list = new AuthBo();
      this.budgetImportBO.personalAssistanceGoods.push(list);

    }



  }
  // private grand=0;
  removePersonalAssisGoods(service, i) {
    if(service.id == null ||service.id == undefined){
    if (this.budgetImportBO.personalAssistanceGoods.length >= 1) {
      if (service.totalAmt == null || service.totalAmt == undefined || service.totalAmt == "") {
        this.budgetImportBO.personalAssistanceGoods.splice(i, 1);
      }
      else {
        this.budgetImportBO.personalAssistanceGoods.splice(i, 1);
        this.budgetImportBO.personalAssistanceGrandTotal = Number((this.budgetImportBO.personalAssistanceGrandTotal - service.totalAmt) .toFixed(4))
      }
      if(this.budgetImportBO.personalAssistanceGoods.length==0){
        let list = new AuthBo();
        this.budgetImportBO.personalAssistanceGoods.push(list);
      }

    }
  }

   else if (service.id != "00000000-0000-0000-0000-000000000000" && service.id != null) {
      let params = new URLSearchParams()
      params.append("Id", service.id)
      this.budgetService.deleteBudgetAuthorization(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

        if (data) {
          this.toastrService.success("Deleted Successfully")
          if (this.budgetImportBO.personalAssistanceGoods.length >= 1) {
            if (service.totalAmt == null || service.totalAmt == undefined || service.totalAmt == "") {
              this.budgetImportBO.personalAssistanceGoods.splice(i, 1);
            }
            else {
              
              this.budgetImportBO.personalAssistanceGoods.splice(i, 1);
              this.budgetImportBO.personalAssistanceGrandTotal = Number((this.budgetImportBO.personalAssistanceGrandTotal - service.totalAmt) .toFixed(4))
            }
            if(this.budgetImportBO.personalAssistanceGoods.length==0){
              let list = new AuthBo();
              this.budgetImportBO.personalAssistanceGoods.push(list);
            }
      
          }
        }

      }, (err: any) => {
        this.toastrService.error("Purchase are created using this authorization" )
      })
    }


  }

  CreateTreatementGoods() {


    let succ: boolean = false;
    if (this.budgetImportBO.treatmentTrainingGoods.length > 0) {
      for (var i = 0; i < this.budgetImportBO.treatmentTrainingGoods.length; i++) {
        if (this.budgetImportBO.treatmentTrainingGoods[i].payorName == '' || this.budgetImportBO.treatmentTrainingGoods[i].payorName == null || this.budgetImportBO.treatmentTrainingGoods[i].payorName == undefined || this.budgetImportBO.treatmentTrainingGoods[i].serviceName == null || this.budgetImportBO.treatmentTrainingGoods[i].serviceName == undefined || this.budgetImportBO.treatmentTrainingGoods[i].serviceName == '') {
          this.toastrService.error('Please Choose Payer and Service');
          succ = true
        }
        else if (this.budgetImportBO.treatmentTrainingGoods[i].rate == null || this.budgetImportBO.treatmentTrainingGoods[i].rate == undefined || this.budgetImportBO.treatmentTrainingGoods[i].totalhours == null || this.budgetImportBO.treatmentTrainingGoods[i].totalhours == undefined) {
          this.toastrService.error('Please Enter Rate and Unit');
          succ = true
        }
      }
    }

    if (!succ) {
      if (this.budgetImportBO.treatmentTrainingGoods.length > 0) {
        let len = this.budgetImportBO.treatmentTrainingGoods.length
        this.ContactColumn = true;

      }


      let list = new AuthBo();
      this.budgetImportBO.treatmentTrainingGoods.push(list);

    }



  }
  // private grand=0;
  removeTreatementGoods(service, i) {
    if(service.id == null ||service.id == undefined){
    if (this.budgetImportBO.treatmentTrainingGoods.length >= 1) {
      if (service.totalAmt == null || service.totalAmt == undefined || service.totalAmt == "") {
        this.budgetImportBO.treatmentTrainingGoods.splice(i, 1);
      }
      else {
        this.budgetImportBO.treatmentTrainingGoods.splice(i, 1);
        this.budgetImportBO.treatmentTrainingGrandTotal = Number((this.budgetImportBO.treatmentTrainingGrandTotal - service.totalAmt) .toFixed(4))
      }
      if(this.budgetImportBO.treatmentTrainingGoods.length==0){
        let list = new AuthBo();
        this.budgetImportBO.treatmentTrainingGoods.push(list);
  
      }

    }
  }

   else if (service.id != "00000000-0000-0000-0000-000000000000" && service.id != null) {
      let params = new URLSearchParams()
      params.append("Id", service.id)
      this.budgetService.deleteBudgetAuthorization(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

        if (data) {
          this.toastrService.success("Deleted Successfully")
          if (this.budgetImportBO.treatmentTrainingGoods.length >= 1) {
            if (service.totalAmt == null || service.totalAmt == undefined || service.totalAmt == "") {
              this.budgetImportBO.treatmentTrainingGoods.splice(i, 1);
            }
            else {
              this.budgetImportBO.treatmentTrainingGoods.splice(i, 1);
              this.budgetImportBO.treatmentTrainingGrandTotal = Number((this.budgetImportBO.treatmentTrainingGrandTotal - service.totalAmt) .toFixed(4))
            }
            if(this.budgetImportBO.treatmentTrainingGoods.length==0){
              let list = new AuthBo();
              this.budgetImportBO.treatmentTrainingGoods.push(list);
        
            }
      
          }
        }

      }, (err: any) => {
        this.toastrService.error("Purchase are created using this authorization" )

      })
    }

  }
  CreateTreatementService() {


    let succ: boolean = false;
    if (this.budgetImportBO.treatmentTraining.length > 0) {
      for (var i = 0; i < this.budgetImportBO.treatmentTraining.length; i++) {
        if (this.budgetImportBO.treatmentTraining[i].payorName == '' || this.budgetImportBO.treatmentTraining[i].payorName == null || this.budgetImportBO.treatmentTraining[i].payorName == undefined || this.budgetImportBO.treatmentTraining[i].serviceName == null || this.budgetImportBO.treatmentTraining[i].serviceName == undefined || this.budgetImportBO.treatmentTraining[i].serviceName == '') {
          this.toastrService.error('Please Choose Payer and Service');
          succ = true
        }
        else if (this.budgetImportBO.treatmentTraining[i].rate == null || this.budgetImportBO.treatmentTraining[i].rate == undefined || this.budgetImportBO.treatmentTraining[i].totalhours == null || this.budgetImportBO.treatmentTraining[i].totalhours == undefined) {
          this.toastrService.error('Please Enter Rate and Unit');
          succ = true
        }
      }
    }

    if (!succ) {
      if (this.budgetImportBO.treatmentTraining.length > 0) {
        let len = this.budgetImportBO.treatmentTraining.length
        this.ContactColumn = true;

      }


      let list = new AuthBo();
      this.budgetImportBO.treatmentTraining.push(list);

    }



  }
  // private grand=0;
  removeTreatementService(service, i) {

    if(service.id == null ||service.id == undefined){


    if (this.budgetImportBO.treatmentTraining.length >= 1) {
      if (service.totalAmt == null || service.totalAmt == undefined || service.totalAmt == "") {
        this.budgetImportBO.treatmentTraining.splice(i, 1);
      }
      else {
        this.budgetImportBO.treatmentTraining.splice(i, 1);
        this.budgetImportBO.treatmentTrainingGrandTotal = Number((this.budgetImportBO.treatmentTrainingGrandTotal - service.totalAmt) .toFixed(4))
      }
      if(this.budgetImportBO.treatmentTraining.length==0){
        
      let list = new AuthBo();
      this.budgetImportBO.treatmentTraining.push(list);

    }
      }

    }
  

   else if (service.id != "00000000-0000-0000-0000-000000000000" && service.id != null) {
      let params = new URLSearchParams()
      params.append("Id", service.id)
      this.budgetService.deleteBudgetAuthorization(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

        if (data) {
          this.toastrService.success("Deleted Successfully")
          
    if (this.budgetImportBO.treatmentTraining.length >= 1) {
      if (service.totalAmt == null || service.totalAmt == undefined || service.totalAmt == "") {
        this.budgetImportBO.treatmentTraining.splice(i, 1);
      }
      else {
        this.budgetImportBO.treatmentTraining.splice(i, 1);
        this.budgetImportBO.treatmentTrainingGrandTotal = Number((this.budgetImportBO.treatmentTrainingGrandTotal - service.totalAmt) .toFixed(4))
      }
      if(this.budgetImportBO.treatmentTraining.length==0){
        
        let list = new AuthBo();
        this.budgetImportBO.treatmentTraining.push(list);
  
      }

    }
        }

      },(err: any) => {
        this.toastrService.error("Timesheets are created using this authorization")
      })
    }

  }


  CreateEnvironementalService() {


    let succ: boolean = false;
    if (this.budgetImportBO.environmentalMods.length > 0) {
      for (var i = 0; i < this.budgetImportBO.environmentalMods.length; i++) {
        if (this.budgetImportBO.environmentalMods[i].payorName == '' || this.budgetImportBO.environmentalMods[i].payorName == null || this.budgetImportBO.environmentalMods[i].payorName == undefined || this.budgetImportBO.environmentalMods[i].serviceName == null || this.budgetImportBO.environmentalMods[i].serviceName == undefined || this.budgetImportBO.environmentalMods[i].serviceName == '') {
          this.toastrService.error('Please Choose Payer and Service');
          succ = true
        }
        else if (this.budgetImportBO.environmentalMods[i].rate == null || this.budgetImportBO.environmentalMods[i].rate == undefined || this.budgetImportBO.environmentalMods[i].totalhours == null || this.budgetImportBO.environmentalMods[i].totalhours == undefined) {
          this.toastrService.error('Please Enter Rate and Unit');
          succ = true
        }
      }
    }

    if (!succ) {
      if (this.budgetImportBO.environmentalMods.length > 0) {
        let len = this.budgetImportBO.environmentalMods.length
        this.ContactColumn = true;

      }


      let list = new AuthBo();
      this.budgetImportBO.environmentalMods.push(list);

    }



  }
  removeEnvironementalService(service, i) {
if(service.id == null ||service.id == undefined){


    if (this.budgetImportBO.environmentalMods.length >= 1) {
      if (service.totalAmt == null || service.totalAmt == undefined || service.totalAmt == "") {
        this.budgetImportBO.environmentalMods.splice(i, 1);
      }
      else {
        this.budgetImportBO.environmentalMods.splice(i, 1);
        this.budgetImportBO.environmentalModsGrandTotal =Number((this.budgetImportBO.environmentalModsGrandTotal - service.totalAmt) .toFixed(4)) ;
      }
      if(this.budgetImportBO.environmentalMods.length ==0){
        let list = new AuthBo();
        this.budgetImportBO.environmentalMods.push(list);
      }
     

    }
  }

   else if (service.id != "00000000-0000-0000-0000-000000000000" && service.id != null) {
      let params = new URLSearchParams()
      params.append("Id", service.id)
      this.budgetService.deleteBudgetAuthorization(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

        if (data) {
          this.toastrService.success("Deleted Successfully")
          if (this.budgetImportBO.environmentalMods.length >= 1) {
            if (service.totalAmt == null || service.totalAmt == undefined || service.totalAmt == "") {
              this.budgetImportBO.environmentalMods.splice(i, 1);
            }
            else {
              this.budgetImportBO.environmentalMods.splice(i, 1);
              this.budgetImportBO.environmentalModsGrandTotal =Number((this.budgetImportBO.environmentalModsGrandTotal - service.totalAmt) .toFixed(4)) ;
            }
            if(this.budgetImportBO.environmentalMods.length ==0){
              let list = new AuthBo();
              this.budgetImportBO.environmentalMods.push(list);
            }
      
          }
        }

      }, (err: any) => {
        this.toastrService.error("Timesheets are created using this authorization")
      })
    }

  }


  CreateEnvironementalGoods() {


    let succ: boolean = false;
    if (this.budgetImportBO.environmentalModsGoods.length > 0) {
      for (var i = 0; i < this.budgetImportBO.environmentalModsGoods.length; i++) {
        if (this.budgetImportBO.environmentalModsGoods[i].payorName == '' || this.budgetImportBO.environmentalModsGoods[i].payorName == null || this.budgetImportBO.environmentalModsGoods[i].payorName == undefined || this.budgetImportBO.environmentalModsGoods[i].serviceName == null || this.budgetImportBO.environmentalModsGoods[i].serviceName == undefined || this.budgetImportBO.environmentalModsGoods[i].serviceName == '') {
          this.toastrService.error('Please Choose Payer and Service');
          succ = true
        }
        else if (this.budgetImportBO.environmentalModsGoods[i].rate == null || this.budgetImportBO.environmentalModsGoods[i].rate == undefined || this.budgetImportBO.environmentalModsGoods[i].totalhours == null || this.budgetImportBO.environmentalModsGoods[i].totalhours == undefined) {
          this.toastrService.error('Please Enter Rate and Unit');
          succ = true
        }
      }
    }

    if (!succ) {
      if (this.budgetImportBO.environmentalModsGoods.length > 0) {
        let len = this.budgetImportBO.environmentalModsGoods.length
        this.ContactColumn = true;

      }


      let list = new AuthBo();
      this.budgetImportBO.environmentalModsGoods.push(list);

    }



  }
  removeEnvironementalGoods(service, i) {
    if(service.id == null ||service.id == undefined){


    if (this.budgetImportBO.environmentalModsGoods.length >= 1) {
      if (service.totalAmt == null || service.totalAmt == undefined || service.totalAmt == "") {
        this.budgetImportBO.environmentalModsGoods.splice(i, 1);
      }
      else {
        this.budgetImportBO.environmentalModsGoods.splice(i, 1);
        this.budgetImportBO.environmentalModsGrandTotal = this.budgetImportBO.environmentalModsGrandTotal - service.totalAmt;
      }
      if(this.budgetImportBO.environmentalModsGoods.length==0){
        let list = new AuthBo();
        this.budgetImportBO.environmentalModsGoods.push(list);
      }

    }
  }
   else  if (service.id != "00000000-0000-0000-0000-000000000000" && service.id != null) {
      let params = new URLSearchParams()
      params.append("Id", service.id)
      this.budgetService.deleteBudgetAuthorization(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

        if (data) {
          this.toastrService.success("Deleted Successfully")
          
    if (this.budgetImportBO.environmentalModsGoods.length >= 1) {
      if (service.totalAmt == null || service.totalAmt == undefined || service.totalAmt == "") {
        this.budgetImportBO.environmentalModsGoods.splice(i, 1);
      }
      else {
        this.budgetImportBO.environmentalModsGoods.splice(i, 1);
        this.budgetImportBO.environmentalModsGrandTotal = this.budgetImportBO.environmentalModsGrandTotal - service.totalAmt;
      }
      if(this.budgetImportBO.environmentalModsGoods.length==0){
        let list = new AuthBo();
        this.budgetImportBO.environmentalModsGoods.push(list);
      }


    }
        }

      }, (err: any) => {
        this.toastrService.error("Purchase are created using this authorization")
      })
    }

  }


  CreateSelfDirected() {


    let succ: boolean = false;
    if (this.budgetImportBO.selfDirectionBO.length > 0) {
      for (var i = 0; i < this.budgetImportBO.selfDirectionBO.length; i++) {
        if (this.budgetImportBO.selfDirectionBO[i].payorName == '' || this.budgetImportBO.selfDirectionBO[i].payorName == null || this.budgetImportBO.selfDirectionBO[i].payorName == undefined || this.budgetImportBO.selfDirectionBO[i].serviceName == null || this.budgetImportBO.selfDirectionBO[i].serviceName == undefined || this.budgetImportBO.selfDirectionBO[i].serviceName == '') {
          this.toastrService.error('Please Choose Payer and Service');
          succ = true
        }
        else if (this.budgetImportBO.selfDirectionBO[i].rate == null || this.budgetImportBO.selfDirectionBO[i].rate == undefined || this.budgetImportBO.selfDirectionBO[i].totalhours == null || this.budgetImportBO.selfDirectionBO[i].totalhours == undefined) {
          this.toastrService.error('Please Enter Rate and Unit');
          succ = true
        }
      }
    }

    if (!succ) {
      if (this.budgetImportBO.selfDirectionBO.length > 0) {
        let len = this.budgetImportBO.selfDirectionBO.length
        this.ContactColumn = true;

      }


      let list = new AuthBo();
      this.budgetImportBO.selfDirectionBO.push(list);

    }



  }
  removeService(service,type) {
    
    if(service.serviceName == null || service.serviceName == undefined) {
      service.rate=0;
      service.totalhours=0;
      service.totalNoWeeksOrMonths=0;
      if (service.totalAmt == null || service.totalAmt == undefined || service.totalAmt == "") {
        service.totalAmt=0;      
      }
      else { 
        if(type == 'Self-Direction')     {
          this.budgetImportBO.selfDirectionBOGrandTotal =Number((this.budgetImportBO.selfDirectionBOGrandTotal - service.totalAmt) .toFixed(4)) 
          service.totalAmt=0;
        } 
        if(type == 'Environmental_Service' || type == 'Environmental_Goods') {
          this.budgetImportBO.environmentalModsGrandTotal = Number((this.budgetImportBO.environmentalModsGrandTotal - service.totalAmt) .toFixed(4))
          service.totalAmt=0;
        }
        if(type == 'Treatment_Service' || type == 'Treatment_Goods') {
          this.budgetImportBO.treatmentTrainingGrandTotal = Number((this.budgetImportBO.treatmentTrainingGrandTotal - service.totalAmt) .toFixed(4))
          service.totalAmt=0;
        }
        if(type == 'Personal_service' || type == 'Personal_goods') {
          this.budgetImportBO.personalAssistanceGrandTotal =Number((this.budgetImportBO.personalAssistanceGrandTotal - service.totalAmt) .toFixed(4))
          service.totalAmt=0;
        }
       
      }

    }
    
    
  
  }
  removeSelfDirected(service, i) {
    if(service.id == null ||service.id == undefined){

    if (this.budgetImportBO.selfDirectionBO.length >= 1) {
      if (service.totalAmt == null || service.totalAmt == undefined || service.totalAmt == "") {
        this.budgetImportBO.selfDirectionBO.splice(i, 1);
      }
      else {
        this.budgetImportBO.selfDirectionBO.splice(i, 1);
        this.budgetImportBO.selfDirectionBOGrandTotal = Number((this.budgetImportBO.selfDirectionBOGrandTotal - service.totalAmt) .toFixed(4))
      }
      if(this.budgetImportBO.selfDirectionBO.length ==0){
        let list = new AuthBo();
        this.budgetImportBO.selfDirectionBO.push(list);
      }

    }
  }
    if (service.id != "00000000-0000-0000-0000-000000000000" && service.id != null) {
      let params = new URLSearchParams()
      params.append("Id", service.id)
      this.budgetService.deleteBudgetAuthorization(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

        if (data) {
          this.toastrService.success("Deleted Successfully")
          
    if (this.budgetImportBO.selfDirectionBO.length >= 1) {
      if (service.totalAmt == null || service.totalAmt == undefined || service.totalAmt == "") {
        this.budgetImportBO.selfDirectionBO.splice(i, 1);
      }
      else {
        this.budgetImportBO.selfDirectionBO.splice(i, 1);
        this.budgetImportBO.selfDirectionBOGrandTotal = Number((this.budgetImportBO.selfDirectionBOGrandTotal - service.totalAmt) .toFixed(4))
      }
      if(this.budgetImportBO.selfDirectionBO.length ==0){
        let list = new AuthBo();
        this.budgetImportBO.selfDirectionBO.push(list);
      }

    }
        }

      }, (err: any) => {
        this.toastrService.error("Timesheets are created using this authorization")
      })
    }

  }
  CreategoalPs(i) {
    if (this.persoanlAssisGoal.length > 0) {
      // this.goalColumn = true;
      // this.budgetImportBO.goalstable[i].isadd=true
    }
    let list = new Goals();
    list.goalType = "Personal Assistance";
    this.persoanlAssisGoal.push(list);
  }

  removegoalPs(goal,Bo :Goals) {
    if (this.persoanlAssisGoal[goal].id == "00000000-0000-0000-0000-000000000000" || this.persoanlAssisGoal[goal].id ==null) {
      // this.persoanlAssisGoal[0].isadd4=false
      this.persoanlAssisGoal.splice(goal, 1);
    } else {
      //delete fun call
      this.persoanlAssisGoal.splice(goal, 1);
        let params = new URLSearchParams()
        params.append("Id", Bo.id)
        this.budgetService.deleteBudegtGoals(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

          if (data) {
            this.toastrService.success("Deleted Successfully")
          }

        }, (err: HttpErrorResponse) => {
          this.toastrService.error(err.error)
        })
      
    }


  }

  CreategoalEnvironmentalGoal(i) {
    if (this.EnvironmentalGoal.length > 0) {
      // this.goalColumn = true;
      // this.budgetImportBO.goalstable[i].isadd=true
    }
    let list = new Goals();
    list.goalType = "Environmental";
    this.EnvironmentalGoal.push(list);
  }

  removegoalEnvironmentalGoal(goal,Bo:Goals) {
    this.EnvironmentalGoal.splice(goal, 1);
    if (this.EnvironmentalGoal.length == 1) {
      // this.persoanlAssisGoal[0].isadd4=false
    }
    if(Bo.id == "00000000-0000-0000-0000-000000000000" || Bo.id ==null)
    {
      
    let params = new URLSearchParams()
    params.append("Id", Bo.id)
    this.budgetService.deleteBudegtGoals(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

      if (data) {
        this.toastrService.success("Deleted Successfully")
      }

    }, (err: HttpErrorResponse) => {
      this.toastrService.error(err.error)
    })
  }
  }

  CreategoalTreatment(i) {
    if (this.TreatmentGoal.length > 0) {
      // this.goalColumn = true;
      // this.budgetImportBO.goalstable[i].isadd=true
    }
    let list = new Goals();
    list.goalType = "Treatment";
    this.TreatmentGoal.push(list);
  }

  removegoalTreatment(goal,Bo:Goals) {
    this.TreatmentGoal.splice(goal, 1);
    if (this.TreatmentGoal.length == 1) {
      // this.persoanlAssisGoal[0].isadd4=false
    }
    if(Bo.id == "00000000-0000-0000-0000-000000000000" || Bo.id ==null)
    {
      
    let params = new URLSearchParams()
    params.append("Id", Bo.id)
    this.budgetService.deleteBudegtGoals(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

      if (data) {
        this.toastrService.success("Deleted Successfully")
      }

    }, (err: HttpErrorResponse) => {
      this.toastrService.error(err.error)
    })
  }
  }


  CreategoalSelf(i) {
    if (this.SelfServiceGoal.length > 0) {
      // this.goalColumn = true;
      // this.budgetImportBO.goalstable[i].isadd=true
    }
    let list = new Goals();
    list.goalType = "Self";
    this.SelfServiceGoal.push(list);
  }

  removegoalSelf(goal) {
    this.SelfServiceGoal.splice(goal, 1);
    if (this.SelfServiceGoal.length == 1) {
      // this.persoanlAssisGoal[0].isadd4=false
    }
  }

  DemographicPhoneFormatWhoCallPhone() {
    this.budgetImportBO.whoDoYouCall_Phone = this.general.converPhoneGoogleLib(this.budgetImportBO.whoDoYouCall_Phone);
  }


  DemographicPhoneFormatWhoCallAltPhone() {
    this.budgetImportBO.alternatePerson_Phone = this.general.converPhoneGoogleLib(this.budgetImportBO.alternatePerson_Phone);
  }

  total: number = 0;
  calculatetotalAmt(Bo: AuthBo, type: string) {
    let totalhrs = (Bo.totalhours != null) ? Bo.totalhours : 1
    let totalweeks = (Bo.totalNoWeeksOrMonths != null) ? Bo.totalNoWeeksOrMonths : 1
    let Amount =  Bo?.rate * totalhrs * totalweeks;
    Bo.totalAmt=Number(Amount.toFixed(4))
    if (type == 'personalAssistance') {
      this.budgetImportBO.personalAssistanceGrandTotal = 0
      this.budgetImportBO.personalAssistance.forEach(element => {
        this.budgetImportBO.personalAssistanceGrandTotal +=  (element.totalAmt != null) ? element.totalAmt : 0;
      this.budgetImportBO.personalAssistanceGrandTotal=Number(this.budgetImportBO.personalAssistanceGrandTotal.toFixed(4))

      });
      this.budgetImportBO.personalAssistanceGoods.forEach(element => {
        this.budgetImportBO.personalAssistanceGrandTotal += (element.totalAmt != null) ? element.totalAmt : 0;
        this.budgetImportBO.personalAssistanceGrandTotal=Number(this.budgetImportBO.personalAssistanceGrandTotal.toFixed(4))


      });
    }
    else if (type == 'TreatmentTraining') {
      this.budgetImportBO.treatmentTrainingGrandTotal = 0
      this.budgetImportBO.treatmentTraining.forEach(element => {
        this.budgetImportBO.treatmentTrainingGrandTotal += (element.totalAmt != null) ? element.totalAmt : 0;
        this.budgetImportBO.treatmentTrainingGrandTotal= Number(this.budgetImportBO.treatmentTrainingGrandTotal.toFixed(4))

      });
      this.budgetImportBO.treatmentTrainingGoods.forEach(element => {
        this.budgetImportBO.treatmentTrainingGrandTotal += (element.totalAmt != null) ? element.totalAmt : 0;
        this.budgetImportBO.treatmentTrainingGrandTotal= Number(this.budgetImportBO.treatmentTrainingGrandTotal.toFixed(4))

      });
    } else if (type == 'Environmental') {
      this.budgetImportBO.environmentalModsGrandTotal = 0
      this.budgetImportBO.environmentalMods.forEach(element => {
        this.budgetImportBO.environmentalModsGrandTotal += (element.totalAmt != null) ? element.totalAmt : 0;
        this.budgetImportBO.environmentalModsGrandTotal= Number(this.budgetImportBO.environmentalModsGrandTotal.toFixed(4))

      });
      this.budgetImportBO.environmentalModsGoods.forEach(element => {
        this.budgetImportBO.environmentalModsGrandTotal += (element.totalAmt != null) ? element.totalAmt : 0;
        this.budgetImportBO.environmentalModsGrandTotal= Number(this.budgetImportBO.environmentalModsGrandTotal.toFixed(4))

      });
    } else if (type == 'self') {
      this.budgetImportBO.selfDirectionBOGrandTotal = 0
      this.budgetImportBO.selfDirectionBO.forEach(element => {
        this.budgetImportBO.selfDirectionBOGrandTotal += (element.totalAmt != null) ? element.totalAmt : 0;
        this.budgetImportBO.selfDirectionBOGrandTotal= Number(this.budgetImportBO.selfDirectionBOGrandTotal.toFixed(4))
      });
    }
    this.total =Number((this.budgetImportBO.personalAssistanceGrandTotal + this.budgetImportBO.treatmentTrainingGrandTotal +
      this.budgetImportBO.environmentalModsGrandTotal + this.budgetImportBO.selfDirectionBOGrandTotal).toFixed(4))
      this.value=(this.budgetImportBO.budgetAmt!=null&&this.budgetImportBO.budgetAmt!=undefined&&this.total!=null&&this.total!=undefined)?Number((this.budgetImportBO.budgetAmt - this.total).toFixed(4)):0

  }

  SAveBudget() {

    let budget: BudgetImportBO = JSON.parse(JSON.stringify(this.budgetImportBO));
    budget.employmentSupportsOrdayservicesAnnualCost = (budget.employmentSupportsOrdayservicesAnnualCost != null && budget.employmentSupportsOrdayservicesAnnualCost != undefined) ? parseFloat(budget.employmentSupportsOrdayservicesAnnualCost.toString()) : null;
    budget.budgetAmt = (budget.budgetAmt != null && budget.budgetAmt != undefined) ? parseFloat(budget.budgetAmt.toString()) : null;
    if (budget.personalAssistance.length > 0) {
      if (budget.personalAssistance.length == 1 && budget.personalAssistance[0].payorName == null && budget.personalAssistance[0].serviceName == null) {
        budget.personalAssistance = [];

      } 
      else {
       budget.personalAssistance= budget.personalAssistance.filter(e=>e.serviceName !=null)
        budget.personalAssistance.forEach(i => {
         
          if (i.rate != null && i.rate != undefined) {
            i.rate = parseFloat(i.rate.toString())
          }
          else {

            i.rate = null
          }

          i.totalhours = (i.totalhours != null && i.totalhours != undefined) ? parseFloat(i.totalhours.toString()) : null;
          // i.weeks=(i.weeks!=null &&i.weeks!=undefined)?parseInt(i.weeks):null;
          i.totalNoWeeksOrMonths = (i.totalNoWeeksOrMonths != null && i.totalNoWeeksOrMonths != undefined) ? parseFloat(i.totalNoWeeksOrMonths.toString()) : null;
          i.clientId = this.budgetImportBO.clientId;
        })


      }

    }

    if (budget.personalAssistanceGoods.length > 0) {
      if (budget.personalAssistanceGoods.length == 1 && budget.personalAssistanceGoods[0].payorName == null && budget.personalAssistanceGoods[0].serviceName == null) {
        budget.personalAssistanceGoods = [];
      }
      else {
        budget.personalAssistanceGoods= budget.personalAssistanceGoods.filter(e=> e.serviceName !=null)
        budget.personalAssistanceGoods.forEach(i => {
          i.rate = (i.rate != null && i.rate != undefined) ? parseFloat(i.rate.toString()) : null;
          i.totalhours = (i.totalhours != null && i.totalhours != undefined) ? parseFloat(i.totalhours.toString()) : null;
          // i.weeks=(i.weeks!=null &&i.weeks!=undefined)?parseInt(i.weeks):null;
          i.totalNoWeeksOrMonths = (i.totalNoWeeksOrMonths != null && i.totalNoWeeksOrMonths != undefined) ? parseFloat(i.totalNoWeeksOrMonths.toString()) : null;
          i.clientId = this.budgetImportBO.clientId;
        })
      }

    }

    if (budget.treatmentTraining.length > 0) {
      if (budget.treatmentTraining.length == 1 && budget.treatmentTraining[0].payorName == null && budget.treatmentTraining[0].serviceName == null) {
        budget.treatmentTraining = [];
      }
      else {
        budget.treatmentTraining =budget.treatmentTraining.filter(e=> e.serviceName !=null)
        budget.treatmentTraining.forEach(i => {
          i.rate = (i.rate != null && i.rate != undefined) ? parseFloat(i.rate.toString()) : null;
          i.totalhours = (i.totalhours != null && i.totalhours != undefined) ? parseFloat(i.totalhours.toString()) : null;
          // i.weeks=(i.weeks!=null &&i.weeks!=undefined)?parseInt(i.weeks):null;
          i.totalNoWeeksOrMonths = (i.totalNoWeeksOrMonths != null && i.totalNoWeeksOrMonths != undefined) ? parseFloat(i.totalNoWeeksOrMonths.toString()) : null;
          i.clientId = this.budgetImportBO.clientId;
        })
      }

    }


    if (budget.treatmentTrainingGoods.length > 0) {
      if (budget.treatmentTrainingGoods.length == 1 && budget.treatmentTrainingGoods[0].payorName == null && budget.treatmentTrainingGoods[0].serviceName == null) {
        budget.treatmentTrainingGoods = [];
      }
      else {
        budget.treatmentTrainingGoods=budget.treatmentTrainingGoods.filter(e=> e.serviceName != null)
        budget.treatmentTrainingGoods.forEach(i => {
          i.rate = (i.rate != null && i.rate != undefined) ? parseFloat(i.rate.toString()) : null;
          i.totalhours = (i.totalhours != null && i.totalhours != undefined) ? parseFloat(i.totalhours.toString()) : null;
          // i.weeks=(i.weeks!=null &&i.weeks!=undefined)?parseInt(i.weeks):null;
          i.totalNoWeeksOrMonths = (i.totalNoWeeksOrMonths != null && i.totalNoWeeksOrMonths != undefined) ? parseFloat(i.totalNoWeeksOrMonths.toString()) : null;
          i.clientId = this.budgetImportBO.clientId;
        })
      }

    }


    if (budget.environmentalMods.length > 0) {
      if (budget.environmentalMods.length == 1 && budget.environmentalMods[0].payorName == null && budget.environmentalMods[0].serviceName == null) {
        budget.environmentalMods = [];
      }
      else {
        budget.environmentalMods = budget.environmentalMods.filter(e=> e.serviceName != null)
        budget.environmentalMods.forEach(i => {
          i.rate = (i.rate != null && i.rate != undefined) ? parseFloat(i.rate.toString()) : null;
          i.totalhours = (i.totalhours != null && i.totalhours != undefined) ? parseFloat(i.totalhours.toString()) : null;
          // i.weeks=(i.weeks!=null &&i.weeks!=undefined)?parseInt(i.weeks):null;
          i.totalNoWeeksOrMonths = (i.totalNoWeeksOrMonths != null && i.totalNoWeeksOrMonths != undefined) ? parseFloat(i.totalNoWeeksOrMonths.toString()) : null;
          i.clientId = this.budgetImportBO.clientId;
        })
      }

    }


    if (budget.environmentalModsGoods.length > 0) {
      if (budget.environmentalModsGoods.length == 1 && budget.environmentalModsGoods[0].payorName == null && budget.environmentalModsGoods[0].serviceName == null) {
        budget.environmentalModsGoods = [];
      }
      else {
        budget.environmentalModsGoods = budget.environmentalModsGoods.filter(e=> e.serviceName != null)

        budget.environmentalModsGoods.forEach(i => {
          i.rate = (i.rate != null && i.rate != undefined) ? parseFloat(i.rate.toString()) : null;
          i.totalhours = (i.totalhours != null && i.totalhours != undefined) ? parseFloat(i.totalhours.toString()) : null;
          // i.weeks=(i.weeks!=null &&i.weeks!=undefined)?parseInt(i.weeks):null;
          i.totalNoWeeksOrMonths = (i.totalNoWeeksOrMonths != null && i.totalNoWeeksOrMonths != undefined) ? parseFloat(i.totalNoWeeksOrMonths.toString()) : null;
          i.clientId = this.budgetImportBO.clientId;
        })
      }

    }


    if (budget.selfDirectionBO.length > 0) {
      if (budget.selfDirectionBO.length == 1 && budget.selfDirectionBO[0].payorName == null && budget.selfDirectionBO[0].serviceName == null) {
        budget.selfDirectionBO = [];
      }
      else {
        budget.selfDirectionBO = budget.selfDirectionBO.filter(e=> e.serviceName != null)

        budget.selfDirectionBO.forEach(i => {
          i.rate = (i.rate != null && i.rate != undefined) ? parseFloat(i.rate.toString()) : null;
          i.totalhours = (i.totalhours != null && i.totalhours != undefined) ? parseFloat(i.totalhours.toString()) : null;
          // i.weeks=(i.weeks!=null &&i.weeks!=undefined)?parseInt(i.weeks):null;
          i.totalNoWeeksOrMonths = (i.totalNoWeeksOrMonths != null && i.totalNoWeeksOrMonths != undefined) ? parseFloat(i.totalNoWeeksOrMonths.toString()) : null;
          i.clientId = this.budgetImportBO.clientId;
        })
      }

    }
    budget.goalstable=[];
    if (this.persoanlAssisGoal.length > 0) {
      if (this.persoanlAssisGoal.length == 1 && (this.persoanlAssisGoal[0].goal == null || this.persoanlAssisGoal[0].goal == "")) {
        this.persoanlAssisGoal = [];

      }
      else {
        this.persoanlAssisGoal.forEach(element => {
          budget.goalstable.push(element)
        });

      }
    }

    if (this.EnvironmentalGoal.length > 0) {
      if (this.EnvironmentalGoal.length == 1 && (this.EnvironmentalGoal[0].goal == null || this.EnvironmentalGoal[0].goal == "")) {
        this.EnvironmentalGoal = [];
      }
      else {
        this.EnvironmentalGoal.forEach(element => {
          budget.goalstable.push(element)
        });

      }
    }


    if (this.TreatmentGoal.length > 0) {
      if (this.TreatmentGoal.length == 1 && (this.TreatmentGoal[0].goal == null || this.TreatmentGoal[0].goal == "")) {
        this.TreatmentGoal = [];
      }
      else {
        this.TreatmentGoal.forEach(element => {
          budget.goalstable.push(element)
        });

      }
    }
    if (budget.goalstable.length > 0) {
      if (budget.goalstable.length == 1 && (budget.goalstable[0].goal == null || budget.goalstable[0].goal == "")) {
        budget.goalstable = [];
      }

    }

    if (budget.additionalContactsBo.length > 0) {
      if (budget.additionalContactsBo.length == 1 && (budget.additionalContactsBo[0].contactId == null || budget.additionalContactsBo[0].contactId == "00000000-0000-0000-0000-000000000000")) {
        budget.additionalContactsBo = [];
      }
    }
    if (budget.representativeContacts.length > 0) {
      if (budget.representativeContacts.length == 1 && (budget.representativeContacts[0].contactId == null || budget.representativeContacts[0].contactId == "00000000-0000-0000-0000-000000000000")) {
        budget.representativeContacts = [];
      }
    }
    if (budget.goalstable.length > 0) {
      if (budget.goalstable.length == 1 && (budget.goalstable[0].goal == null || budget.goalstable[0].goal == "")) {
        budget.goalstable = [];
      }
    }

    if (budget.scheduleBOsp.length > 0) {
      if (budget.scheduleBOsp.length == 1 && (budget.scheduleBOsp[0].monday == null || budget.scheduleBOsp[0].monday == "")
        && (budget.scheduleBOsp[0].tuesday == null || budget.scheduleBOsp[0].tuesday == "")
        && (budget.scheduleBOsp[0].wednesday == null || budget.scheduleBOsp[0].wednesday == "")
        && (budget.scheduleBOsp[0].thursday == null || budget.scheduleBOsp[0].thursday == "")
        && (budget.scheduleBOsp[0].friday == null || budget.scheduleBOsp[0].friday == "")) {
        budget.scheduleBOsp = [];
      }
    }

    if (budget.budgetEvaluationOfLastYearPlansBO.length > 0) {
      if (budget.budgetEvaluationOfLastYearPlansBO.length == 1 && (budget.budgetEvaluationOfLastYearPlansBO[0].evaluationPlanGoal == null || budget.budgetEvaluationOfLastYearPlansBO[0].evaluationPlanGoal == "")
      ) {
        budget.budgetEvaluationOfLastYearPlansBO = [];
      }
    }

    if (budget.budgetExpendituresMonitor.length > 0) {
      if (budget.budgetExpendituresMonitor.length == 1 && (budget.budgetExpendituresMonitor[0].healthandSafety == null || budget.budgetExpendituresMonitor[0].healthandSafety == "") &&
        (budget.budgetExpendituresMonitor[0].howoffen == null || budget.budgetExpendituresMonitor[0].howoffen == "") && (budget.budgetExpendituresMonitor[0].fiscalSupportEntityStaff_Howoffen == null || budget.budgetExpendituresMonitor[0].fiscalSupportEntityStaff_Howoffen == "")) {
        budget.budgetExpendituresMonitor = [];
      }
    }

    if (budget.budgetHealthandSafetyMonitors.length > 0) {
      if (budget.budgetHealthandSafetyMonitors.length == 1 && (budget.budgetHealthandSafetyMonitors[0].healthandSafety == null || budget.budgetHealthandSafetyMonitors[0].healthandSafety == "")
        && (budget.budgetHealthandSafetyMonitors[0].howoffen == null || budget.budgetHealthandSafetyMonitors[0].howoffen == "")) {
        budget.budgetHealthandSafetyMonitors = [];
      }
    }

   
    budget.budgetStartDate = (budget.budgetStartDate != null && budget.budgetStartDate != '' && budget.budgetStartDate != undefined) ? (new Date(new Date(budget.budgetStartDate).toDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "") : null;
    budget.budgetEndDate = (budget.budgetEndDate != null && budget.budgetEndDate != '' && budget.budgetEndDate != undefined) ? (new Date(new Date(budget.budgetEndDate).toDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "") : null;
    budget.budgetdate = (budget.budgetdate != null && budget.budgetdate != '' && budget.budgetdate != undefined) ? (new Date(new Date(budget.budgetdate).toDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "") : null;

    let u1=budget.personalAssistance[0]
    let u2=budget.treatmentTraining[0]
    let u3=budget.environmentalMods[0]
    let u4=budget.selfDirectionBO[0]


    budget.healthandSafetyPlanDate = (budget.healthandSafetyPlanDate != '' && budget.healthandSafetyPlanDate != null && budget.healthandSafetyPlanDate != undefined) ? (new Date(new Date(budget.healthandSafetyPlanDate).toDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "") : null;
    budget.whatwillDoInCaseDate = (budget.whatwillDoInCaseDate != '' && budget.whatwillDoInCaseDate != null && budget.whatwillDoInCaseDate) ? (new Date(new Date(budget.whatwillDoInCaseDate).toDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "") : null;
    //  budget.id= this.budgetPlan.id;
    
    let personalAssisError = budget.personalAssistance?.filter(p => p.rate == null || p.totalhours == null || p.totalNoWeeksOrMonths == null || p.companyName == null || p.companyName == undefined || p.payorName == null)
    let personalAssisGoodsError = budget.personalAssistanceGoods?.filter(p => p.rate == null || p.totalhours == null || p.totalNoWeeksOrMonths == null || p.companyName == null || p.companyName == undefined || p.payorName == null)
    let treatementandtrainingError = budget.treatmentTraining?.filter(p => p.rate == null || p.totalhours == null || p.totalNoWeeksOrMonths == null || p.companyName == null || p.companyName == undefined || p.payorName == null)
    let treatementandtrainingGoodError = budget.treatmentTrainingGoods?.filter(p => p.rate == null || p.totalhours == null || p.totalNoWeeksOrMonths == null || p.companyName == null || p.companyName == undefined || p.payorName == null)
    let EnvironmentserviceError = budget.environmentalMods?.filter(p => p.rate == null || p.totalhours == null || p.totalNoWeeksOrMonths == null || p.companyName == null || p.companyName == undefined || p.payorName == null)
    let EnvironmentGoodsError = budget.environmentalModsGoods?.filter(p => p.rate == null || p.totalhours == null || p.totalNoWeeksOrMonths == null || p.companyName == null || p.companyName == undefined || p.payorName == null)
    let SelfServiceError = budget.selfDirectionBO?.filter(p => p.rate == null || p.totalhours == null || p.totalNoWeeksOrMonths == null || p.companyName == null || p.companyName == undefined || p.payorName == null)
  

    if (personalAssisError.length != 0 ||
      personalAssisGoodsError.length != 0 || treatementandtrainingError.length != 0 || treatementandtrainingGoodError.length != 0
      || EnvironmentserviceError.length != 0 || EnvironmentGoodsError.length != 0 || SelfServiceError.length != 0) {
      if (personalAssisError.length != 0)
        this.toastrService.error("Please fill all the Mandatory fields in Personal Assisstance Service");
      if (personalAssisGoodsError.length != 0)
        this.toastrService.error("Please fill all the Mandatory fields in Personal Assisstance Goods");
      if (treatementandtrainingError.length != 0)
        this.toastrService.error("Please fill all the Mandatory fields in Treatment and Training Services");
      if (treatementandtrainingGoodError.length != 0)
        this.toastrService.error("Please fill all the Mandatory fields in Treatment and Training Goods");

      if (EnvironmentserviceError.length != 0)
        this.toastrService.error("Please fill all the Mandatory fields in Environmental Modifications and Provisions Services");
      if (EnvironmentGoodsError.length != 0)
        this.toastrService.error("Please fill all the Mandatory fields in Environmental Modifications and Provisions Goods");
      if (SelfServiceError.length != 0)
        this.toastrService.error("Please fill all the Mandatory fields in Self-Direction Support Activities");

      this.budgetImportBO.budgetStartDate = this.datepipe.transform(this.budgetImportBO.budgetStartDate, "MM/dd/yyyy")
      this.budgetImportBO.budgetEndDate = this.datepipe.transform(this.budgetImportBO.budgetEndDate, "MM/dd/yyyy")
      this.budgetImportBO.budgetdate = this.datepipe.transform(this.budgetImportBO.budgetdate, "MM/dd/yyyy")
      this.budgetImportBO.healthandSafetyPlanDate = this.datepipe.transform(this.budgetImportBO.healthandSafetyPlanDate, "MM/dd/yyyy")
      this.budgetImportBO.whatwillDoInCaseDate = this.datepipe.transform(this.budgetImportBO.whatwillDoInCaseDate, "MM/dd/yyyy")

    } 
    else if((u1==null||u1==undefined)&&(u2==null||u2==undefined)&&(u3==null||u3==undefined)&&(u4==null||u4==undefined)){
      this.toastrService.error('Please enter atleast 1 authorization record');
    } 
    
    else {
      this.budgetService.savebudget(budget).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

        if (this.budgetPlan.id == "00000000-0000-0000-0000-000000000000") {
          this.toastrService.success('Budget Imported Successfully');
        }
        else {
          this.toastrService.success('Budget Updated Successfully');
        }

        this.closeFun();
      }, (err: any) => {

        this.toastrService.error(err);
        this.budgetImportBO.budgetStartDate = this.datepipe.transform(this.budgetImportBO.budgetStartDate, "MM/dd/yyyy")
        this.budgetImportBO.budgetEndDate = this.datepipe.transform(this.budgetImportBO.budgetEndDate, "MM/dd/yyyy")
        this.budgetImportBO.budgetdate = this.datepipe.transform(this.budgetImportBO.budgetdate, "MM/dd/yyyy")
        this.budgetImportBO.healthandSafetyPlanDate = this.datepipe.transform(this.budgetImportBO.healthandSafetyPlanDate, "MM/dd/yyyy")
        this.budgetImportBO.whatwillDoInCaseDate = this.datepipe.transform(this.budgetImportBO.whatwillDoInCaseDate, "MM/dd/yyyy")


      })
    }


  }


  PersonServiceList: any = []
  //..............................................GetServiceDropdown.................................
  GetPersonalServiceDropdown() {
    let params = new URLSearchParams();
    params.append("ServiceGroupName", "Personal Assistance")
    if (this.global.LoginEntityType == 'ADMIN') {
      this.budgetService.getServiceDropdownForAdmin(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.PersonServiceList = data;
      }, (err: any) => {
        if (err) {
          this.toastrService.error(err, 'Error'), 8000;
        }
      });


    
    }
    else {

      this.budgetService.getServiceDropdownForotherUser(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.PersonServiceList = data;
      }, (err: any) => {
        if (err) {
          this.toastrService.error(err, 'Error'), 8000;
        }
      });
     
    }
  }
  TreatmentList: any = []
  GetTreatMentDropdown() {
    let params = new URLSearchParams();
    params.append("ServiceGroupName", "Treatment & Training")
    if (this.global.LoginEntityType == 'ADMIN') {
      this.budgetService.getServiceDropdownForAdmin(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.TreatmentList = data;
      }, (err: any) => {
        if (err) {
          this.toastrService.error(err, 'Error'), 8000;
        }
      });
    }
    else {
      this.budgetService.getServiceDropdownForotherUser(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.TreatmentList = data;
      }, (err: any) => {
        if (err) {
          this.toastrService.error(err, 'Error'), 8000;
        }
      });
    }
  }
  EnviromList: any = []
  GetEnvironmentDropdown() {
    let params = new URLSearchParams();
    params.append("ServiceGroupName", "Enviromental Mods & Provisions")
    if (this.global.LoginEntityType == 'ADMIN') {
      this.budgetService.getServiceDropdownForAdmin(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.EnviromList = data;
      }, (err: any) => {
        if (err) {
          this.toastrService.error(err, 'Error'), 8000;
        }
      });
    }
    else {
      this.budgetService.getServiceDropdownForotherUser(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.EnviromList = data;
      }, (err: any) => {
        if (err) {
          this.toastrService.error(err, 'Error'), 8000;
        }
      });
    }
  }
  SelfList: any = []
  GetSelfDropdown() {
    let params = new URLSearchParams();
    params.append("ServiceGroupName", "Self-Direction Support Activities")
    if (this.global.LoginEntityType == 'ADMIN') {
      this.budgetService.getServiceDropdownForAdmin(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.SelfList = data;
      }, (err: any) => {
        if (err) {
          this.toastrService.error(err, 'Error'), 8000;
        }
      });
    }
    else {
      this.budgetService.getServiceDropdownForotherUser(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.SelfList = data;
      }, (err: any) => {
        if (err) {
          this.toastrService.error(err, 'Error'), 8000;
        }
      });
    }
  }

  clearbasicadvance()
  {
    this.BudgetView.isbasicadvance = "";
  }



  recalculatetotal(){
    this.total =Number((this.budgetImportBO.personalAssistanceGrandTotal + this.budgetImportBO.treatmentTrainingGrandTotal +
      this.budgetImportBO.environmentalModsGrandTotal + this.budgetImportBO.selfDirectionBOGrandTotal).toFixed(4))
      this.value=(this.budgetImportBO.budgetAmt!=null&&this.budgetImportBO.budgetAmt!=undefined&&this.total!=null&&this.total!=undefined)?Number((this.budgetImportBO.budgetAmt - this.total).toFixed(4)):0

  }

  getAllClientDropDown() {
    this.budgetformService.GetAllClientsDropDownbyAgency().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.allClientDropDown = data;
      this.allClientDropDown.forEach(e => {
        e.id = e.id;
      });
      this.ClinetDropDown = this.allClientDropDown.filter(e => e.status == "ACTIVE");
    });

  }


  
}
